/**
 * Artmere Custom JS
 * cm/inches toggle for product size options
 *
 * Note: Currency/localization form submission is handled by theme's custom-async.js
 */

(function() {
  'use strict';

  /* ============================================================
   * CM / INCHES TOGGLE for product size options
   * ============================================================ */
  var INCH_TO_CM = 2.54;
  var STORAGE_KEY = 'artmere_unit';
  var ATTRIBUTION_STORAGE_KEY = 'artmere_attribution_v1';
  var COLLECTOR_CREDIT_CODE = 'COLLECTOR100_US_JUN26';
  var COLLECTOR_CREDIT_AMOUNT = 100;
  var COLLECTOR_CREDIT_MINIMUM = 800;
  var COLLECTOR_CREDIT_CURRENCY = 'USD';
  var COLLECTOR_CREDIT_EVENT = 'collector credit requested';
  var CART_CAPTURE_SUBMIT_KEY = 'artmere_cart_capture_submit';
  var CART_CAPTURE_SUBMIT_AT_KEY = 'artmere_cart_capture_submit_at';

  function isGermanPage() {
    return window.location.pathname.indexOf('/de') === 0 ||
      (document.documentElement.lang || '').toLowerCase().indexOf('de') === 0;
  }

  function getDefaultUnit() {
    // Detect from Shopify country code in the localization form
    var countryInput = document.querySelector('.localization-form input[name="country_code"]');
    var country = countryInput ? countryInput.value : '';
    // Metric countries get cm, US/CA get inches
    if (country === 'US') return 'in';
    return 'cm';
  }

  function getStoredUnit() {
    try {
      return localStorage.getItem(STORAGE_KEY) || getDefaultUnit();
    } catch(e) {
      return getDefaultUnit();
    }
  }

  function storeUnit(unit) {
    try { localStorage.setItem(STORAGE_KEY, unit); } catch(e) {}
  }

  function getMarketingAttribution() {
    try {
      return JSON.parse(sessionStorage.getItem(ATTRIBUTION_STORAGE_KEY) || '{}') || {};
    } catch(e) {
      return {};
    }
  }

  function initMarketingAttributionStorage() {
    var params = new URLSearchParams(window.location.search || '');
    var keys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'fbclid', 'gclid'];
    var attribution = {};

    keys.forEach(function(key) {
      var value = params.get(key);
      if (value) {
        attribution[key] = value.slice(0, 120);
      }
    });

    if (Object.keys(attribution).length === 0) return;

    attribution.landing_path = window.location.pathname;
    attribution.captured_at = new Date().toISOString();

    try {
      sessionStorage.setItem(ATTRIBUTION_STORAGE_KEY, JSON.stringify(attribution));
    } catch(e) {}
  }


  /* ============================================================
   * MEASUREMENT ACCEPTANCE V1
   * Privacy-safe acquisition continuity + missing-middle events.
   * ============================================================ */
  var MEASUREMENT_VERSION = 'measurement_acceptance_v1';
  var MEASUREMENT_CONTRACT_VERSION = 'measurement_acceptance_v1.2';
  var CART_SYNC_STORAGE_KEY = 'artmere_context_cart_sync_v1';
  var EVENT_DEDUP_STORAGE_KEY = 'artmere_measurement_dedup_v1_2';
  var INTERNAL_QA_STORAGE_KEY = 'artmere_internal_qa_v1';
  var INTERNAL_QA_LOG_STORAGE_KEY = 'artmere_measurement_qa_log_v1_2';
  var SEARCH_V2_SELECTION_STORAGE_KEY = 'artmere_search_v2_selection_v1';

  function measurementRoute(path) {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return root.replace(/\/$/, '') + '/' + String(path || '').replace(/^\//, '');
  }

  function internalQaTraffic() {
    var params = new URLSearchParams(window.location.search || '');
    var marked = params.get('artmere_qa') === '1' || params.get('utm_source') === 'internal_qa';
    try {
      marked = marked || getMarketingAttribution().utm_source === 'internal_qa';
      if (marked) sessionStorage.setItem(INTERNAL_QA_STORAGE_KEY, '1');
      return marked || sessionStorage.getItem(INTERNAL_QA_STORAGE_KEY) === '1';
    } catch(e) {
      return marked;
    }
  }

  function nonProductionMeasurementReason() {
    var params = new URLSearchParams(window.location.search || '');
    if (internalQaTraffic()) return 'internal_qa';
    if (params.has('preview_theme_id')) return 'preview_theme';
    if (window.Shopify && (Shopify.designMode === true || Shopify.visualPreviewMode === true)) return 'theme_editor';
    if (document.documentElement && document.documentElement.classList.contains('theme-editor')) return 'theme_editor';
    if (window.Shopify && Shopify.theme && Shopify.theme.id && String(Shopify.theme.id) !== '187731804489') return 'preview_theme';
    return '';
  }

  function analyticsExplicitlyDenied() {
    try {
      return !!(window.Shopify && Shopify.customerPrivacy &&
        typeof Shopify.customerPrivacy.analyticsProcessingAllowed === 'function' &&
        Shopify.customerPrivacy.analyticsProcessingAllowed() === false);
    } catch(e) {
      return false;
    }
  }

  function boundedMeasurementValue(value, limit) {
    return String(value == null ? '' : value).slice(0, limit || 120);
  }

  function measurementHash(value) {
    var text = String(value || '');
    var hash = 2166136261;
    for (var i = 0; i < text.length; i += 1) {
      hash ^= text.charCodeAt(i);
      hash = Math.imul(hash, 16777619);
    }
    return ('00000000' + (hash >>> 0).toString(16)).slice(-8);
  }

  function cartFingerprint(cart) {
    var items = (cart && cart.items) || [];
    var parts = items.map(function(item) {
      return [item.variant_id || item.id || '', item.quantity || 0].join(':');
    }).sort();
    return measurementHash(parts.join('|') + '|' + Number((cart && cart.total_price) || 0));
  }

  function measurementEventId() {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') {
      return window.crypto.randomUUID();
    }
    return 'artmere-' + Date.now() + '-' + Math.random().toString(16).slice(2);
  }

  function measurementDedupKey(name, cart, surface, discriminator) {
    return [
      MEASUREMENT_CONTRACT_VERSION,
      name,
      surface || 'storefront',
      cartFingerprint(cart || {}),
      boundedMeasurementValue(discriminator || '', 160)
    ].join(':');
  }

  function claimMeasurementDedupKey(key) {
    var compact = 'mdk_' + measurementHash(key) + measurementHash(String(key).split('').reverse().join(''));
    window.__artmereMeasurementDedup = window.__artmereMeasurementDedup || {};
    if (window.__artmereMeasurementDedup[compact]) return '';
    try {
      var seen = JSON.parse(sessionStorage.getItem(EVENT_DEDUP_STORAGE_KEY) || '{}') || {};
      if (seen[compact]) return '';
      seen[compact] = new Date().toISOString();
      var entries = Object.keys(seen).sort(function(left, right) {
        return String(seen[left]).localeCompare(String(seen[right]));
      });
      while (entries.length > 100) delete seen[entries.shift()];
      sessionStorage.setItem(EVENT_DEDUP_STORAGE_KEY, JSON.stringify(seen));
    } catch(e) {}
    window.__artmereMeasurementDedup[compact] = true;
    return compact;
  }

  function measurementPayload(cart, extra, deduplicationKey) {
    var attribution = getMarketingAttribution();
    var items = (cart && cart.items) || [];
    var payload = {
      measurement_version: MEASUREMENT_VERSION,
      event_contract_version: MEASUREMENT_CONTRACT_VERSION,
      event_id: measurementEventId(),
      deduplication_key: deduplicationKey,
      timestamp: new Date().toISOString(),
      event_timestamp: new Date().toISOString(),
      page_path: window.location.pathname,
      surface: (extra && extra.surface) || 'storefront',
      cart_value: Number((cart && cart.total_price) || 0) / 100,
      currency: boundedMeasurementValue((cart && cart.currency) || '', 12),
      item_count: Number((cart && cart.item_count) || 0),
      product_handles: items.map(function(item) {
        return boundedMeasurementValue(item.handle || '', 120);
      }).filter(Boolean).slice(0, 25).join(','),
      cart_fingerprint: cartFingerprint(cart || {}),
      utm_source: boundedMeasurementValue(attribution.utm_source, 120),
      utm_medium: boundedMeasurementValue(attribution.utm_medium, 120),
      utm_campaign: boundedMeasurementValue(attribution.utm_campaign, 120),
      utm_content: boundedMeasurementValue(attribution.utm_content, 120),
      utm_term: boundedMeasurementValue(attribution.utm_term, 120),
      landing_path: boundedMeasurementValue(attribution.landing_path, 512),
      utm_context: Object.keys(attribution).length ? 'present' : 'absent',
      meta_click_present: attribution.fbclid ? '1' : '0',
      google_click_present: attribution.gclid ? '1' : '0',
      artmere_internal_qa: internalQaTraffic() ? '1' : '0'
    };
    if (payload.artmere_internal_qa === '1') payload.traffic_type = 'internal';
    Object.keys(extra || {}).forEach(function(key) {
      payload[key] = extra[key];
    });
    return payload;
  }

  // GA4 on this storefront is delivered by Shopify Web Pixels. window.gtag never
  // exists in page scope and no GTM container consumes window.dataLayer, so
  // Shopify.analytics.publish is the only working route. Custom events published
  // before the pixel sandbox has subscribed are dropped without an error, which
  // is why interaction events arrived in GA4 and the early list-impression event
  // did not. Events that fire during page init must go through this gate.
  var MEASUREMENT_TRANSPORT_MAX_WAIT_MS = 15000;
  var MEASUREMENT_TRANSPORT_SETTLE_MS = 400;

  // window.gtag is the only route that demonstrably reaches GA4 from this
  // storefront: interaction events published after it exists arrive, and the
  // Shopify analytics bus alone does not forward custom events. gtag is injected
  // asynchronously after consent resolution, so an init-time publish races it.
  // Wait for gtag; if it never appears, publish anyway after the timeout so the
  // Shopify analytics bus still receives the event exactly as it does today.
  function measurementTransportReady() {
    try {
      return typeof window.gtag === 'function';
    } catch(e) {
      return false;
    }
  }

  function whenMeasurementTransportReady(callback) {
    var fired = false;
    var started = Date.now();
    function run() {
      if (fired) return;
      fired = true;
      callback();
    }
    function attempt() {
      if (fired) return;
      if (measurementTransportReady()) {
        setTimeout(run, MEASUREMENT_TRANSPORT_SETTLE_MS);
        return;
      }
      if (Date.now() - started >= MEASUREMENT_TRANSPORT_MAX_WAIT_MS) {
        run();
        return;
      }
      setTimeout(attempt, 200);
    }
    if (document.readyState === 'complete') {
      attempt();
    } else {
      window.addEventListener('load', attempt);
      setTimeout(attempt, MEASUREMENT_TRANSPORT_MAX_WAIT_MS);
    }
  }

  // One shared publication route for theme files outside this bundle. Reuses the
  // existing consent check, deduplication and payload contract. No second
  // analytics integration and no separate transport.
  window.artmerePublishMeasurementEvent = function(name, extra, discriminator) {
    if (!name) return false;
    var context = extra || {};
    return publishMeasurementEvent(
      name, {}, context,
      measurementDedupKey(name, {}, context.surface || 'storefront', discriminator || measurementEventId())
    );
  };

  function publishMeasurementEvent(name, cart, extra, rawDedupKey) {
    var nonProductionReason = nonProductionMeasurementReason();
    if (nonProductionReason) {
      if (document.documentElement) {
        document.documentElement.setAttribute('data-artmere-measurement-suppressed', nonProductionReason);
      }
      return false;
    }
    if (analyticsExplicitlyDenied() && !internalQaTraffic()) return false;
    var deduplicationKey = claimMeasurementDedupKey(rawDedupKey);
    if (!deduplicationKey) return false;
    var payload = measurementPayload(cart || {}, extra || {}, deduplicationKey);
    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish(name, payload);
      }
    } catch(e) {}
    try {
      if (typeof window.gtag === 'function') {
        window.gtag('event', name, payload);
      } else {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(Object.assign({ event: name }, payload));
      }
    } catch(e) {}
    try {
      document.dispatchEvent(new CustomEvent('artmere:measurement', {
        detail: Object.assign({ event: name }, payload)
      }));
    } catch(e) {}
    if (internalQaTraffic() && document.documentElement) {
      document.documentElement.setAttribute('data-artmere-last-measurement-event', name);
      document.documentElement.setAttribute(
        'data-artmere-last-measurement-payload',
        JSON.stringify(Object.assign({ event: name }, payload))
      );
      try {
        var qaLog = JSON.parse(sessionStorage.getItem(INTERNAL_QA_LOG_STORAGE_KEY) || '[]');
        qaLog.push(Object.assign({ event: name }, payload));
        qaLog = qaLog.slice(-30);
        sessionStorage.setItem(INTERNAL_QA_LOG_STORAGE_KEY, JSON.stringify(qaLog));
        document.documentElement.setAttribute('data-artmere-measurement-qa-log', JSON.stringify(qaLog));
      } catch(e) {}
    }
    return true;
  }

  function sha256Prefix(value) {
    if (!value || !window.crypto || !window.crypto.subtle || !window.TextEncoder) {
      return Promise.resolve('');
    }
    return window.crypto.subtle.digest('SHA-256', new TextEncoder().encode(String(value)))
      .then(function(buffer) {
        return Array.from(new Uint8Array(buffer)).map(function(byte) {
          return byte.toString(16).padStart(2, '0');
        }).join('').slice(0, 16);
      }).catch(function() { return ''; });
  }

  function privateCartAttributes(attribution) {
    return Promise.all([
      sha256Prefix(attribution.fbclid),
      sha256Prefix(attribution.gclid)
    ]).then(function(hashes) {
      var attributes = {
        __artmere_context_version: MEASUREMENT_VERSION,
        __artmere_utm_source: boundedMeasurementValue(attribution.utm_source, 120),
        __artmere_utm_medium: boundedMeasurementValue(attribution.utm_medium, 120),
        __artmere_utm_campaign: boundedMeasurementValue(attribution.utm_campaign, 120),
        __artmere_utm_content: boundedMeasurementValue(attribution.utm_content, 120),
        __artmere_utm_term: boundedMeasurementValue(attribution.utm_term, 120),
        __artmere_landing_path: boundedMeasurementValue(attribution.landing_path, 512),
        __artmere_captured_at: boundedMeasurementValue(attribution.captured_at, 40),
        __artmere_click_meta_present: attribution.fbclid ? '1' : '0',
        __artmere_click_google_present: attribution.gclid ? '1' : '0',
        __artmere_click_meta_hash: hashes[0],
        __artmere_click_google_hash: hashes[1],
        __artmere_internal_qa: internalQaTraffic() ? '1' : '0'
      };
      Object.keys(attributes).forEach(function(key) {
        if (attributes[key] === '') delete attributes[key];
      });
      return attributes;
    });
  }

  function syncAcquisitionToCart(cart) {
    if (!cart || Number(cart.item_count || 0) < 1) return Promise.resolve(false);
    if (analyticsExplicitlyDenied() && !internalQaTraffic()) return Promise.resolve(false);
    var attribution = getMarketingAttribution();
    if (Object.keys(attribution).length === 0 && !internalQaTraffic()) return Promise.resolve(false);
    return privateCartAttributes(attribution).then(function(attributes) {
      var signature = cartFingerprint(cart) + ':' + measurementHash(JSON.stringify(attributes));
      try {
        if (sessionStorage.getItem(CART_SYNC_STORAGE_KEY) === signature) return false;
      } catch(e) {}
      return fetch(measurementRoute('cart/update.js'), {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ attributes: attributes })
      }).then(function(response) {
        if (!response.ok) throw new Error('cart context update failed');
        try { sessionStorage.setItem(CART_SYNC_STORAGE_KEY, signature); } catch(e) {}
        if (internalQaTraffic() && document.documentElement) {
          document.documentElement.setAttribute('data-artmere-context-sync', 'ok');
        }
        return true;
      }).catch(function() {
        if (internalQaTraffic() && document.documentElement) {
          document.documentElement.setAttribute('data-artmere-context-sync', 'failed');
        }
        return false;
      });
    });
  }

  function readMeasurementCart() {
    return fetch(measurementRoute('cart.js'), {
      credentials: 'same-origin', headers: { 'Accept': 'application/json' }
    }).then(function(response) {
      if (!response.ok) throw new Error('cart.js unavailable');
      return response.json();
    }).then(function(cart) {
      window.__artmereMeasurementCart = cart;
      return cart;
    });
  }

  function restoreInternalQaLog() {
    if (!internalQaTraffic() || !document.documentElement) return;
    try {
      var qaLog = sessionStorage.getItem(INTERNAL_QA_LOG_STORAGE_KEY);
      if (qaLog) document.documentElement.setAttribute('data-artmere-measurement-qa-log', qaLog);
    } catch(e) {}
  }

  function publishCartView(surface, providedCart) {
    (providedCart ? Promise.resolve(providedCart) : readMeasurementCart()).then(function(cart) {
      if (!cart || Number(cart.item_count || 0) < 1) return;
      syncAcquisitionToCart(cart);
      publishMeasurementEvent(
        'artmere_missing_middle_cart_viewed',
        cart,
        { surface: surface },
        measurementDedupKey('cart_viewed', cart, surface, 'visible')
      );
    }).catch(function() {});
  }

  function cartSurface() {
    if (/\/cart\/?$/.test(window.location.pathname)) return 'cart_page';
    var drawer = document.querySelector(
      '.m6pn#cart.toggle[aria-hidden="false"], [data-cart-drawer][aria-hidden="false"], cart-drawer[open], #mini-cart[aria-hidden="false"]'
    );
    if (drawer) return 'cart_drawer';
    return '';
  }

  function interactionDedupKey(event, name, cart, surface) {
    if (!event.__artmereMeasurementInteractionId) {
      event.__artmereMeasurementInteractionId = measurementEventId();
    }
    return measurementDedupKey(name, cart, surface, event.__artmereMeasurementInteractionId);
  }

  function recentCaptureSubmitToken() {
    try {
      if (sessionStorage.getItem(CART_CAPTURE_SUBMIT_KEY) !== '1') return '';
      return sessionStorage.getItem(CART_CAPTURE_SUBMIT_AT_KEY) || 'submitted';
    } catch(e) {
      return '';
    }
  }

  function initMeasurementAcceptance() {
    if (window.__artmereMeasurementAcceptanceInitialized) {
      var rerenderedSurface = cartSurface();
      if (rerenderedSurface) publishCartView(rerenderedSurface);
      return;
    }
    window.__artmereMeasurementAcceptanceInitialized = true;
    restoreInternalQaLog();
    var initialSurface = cartSurface();
    readMeasurementCart().then(function(cart) {
      if (initialSurface) publishCartView(initialSurface, cart);
    }).catch(function() {});

    document.addEventListener('click', function(event) {
      var cartTrigger = event.target && event.target.closest ? event.target.closest('[data-panel="cart"]') : null;
      if (cartTrigger) setTimeout(function() { publishCartView('cart_drawer'); }, 450);
      var target = event.target && event.target.closest ? event.target.closest(
        '[name="checkout"], a[href*="/checkout"], button.checkout, .checkout-button, [data-checkout]'
      ) : null;
      if (!target) return;
      var surface = cartSurface() || 'checkout_cta';
      var cachedCart = window.__artmereMeasurementCart;
      var checkoutPublished = false;
      if (cachedCart) {
        checkoutPublished = publishMeasurementEvent(
          'artmere_mm_checkout_cta_clicked',
          cachedCart,
          { surface: surface },
          interactionDedupKey(event, 'checkout_cta_clicked', cachedCart, surface)
        );
      }
      readMeasurementCart().then(function(cart) {
        syncAcquisitionToCart(cart);
        if (!checkoutPublished) {
          publishMeasurementEvent(
            'artmere_mm_checkout_cta_clicked',
            cart,
            { surface: surface },
            interactionDedupKey(event, 'checkout_cta_clicked', cart, surface)
          );
        }
      }).catch(function() {});
    }, true);

    document.addEventListener('submit', function(event) {
      if (!event.target || !event.target.matches('form.artmere-cart-capture-form')) return;
      var form = event.target;
      if (form.getAttribute('data-artmere-measurement-submit-fired') === 'true') return;
      form.setAttribute('data-artmere-measurement-submit-fired', 'true');
      var submitToken = measurementEventId();
      var cachedCart = window.__artmereMeasurementCart;
      var submitPublished = false;
      if (cachedCart) {
        submitPublished = publishMeasurementEvent(
          'artmere_missing_middle_save_submit',
          cachedCart,
          { surface: 'cart_save' },
          measurementDedupKey('save_submit', cachedCart, 'cart_save', submitToken)
        );
      }
      readMeasurementCart().then(function(cart) {
        if (!submitPublished) {
          publishMeasurementEvent(
            'artmere_missing_middle_save_submit',
            cart,
            { surface: 'cart_save' },
            measurementDedupKey('save_submit', cart, 'cart_save', submitToken)
          );
        }
      }).catch(function() {});
    }, true);

    document.addEventListener('invalid', function(event) {
      if (!event.target || !event.target.closest || !event.target.closest('form.artmere-cart-capture-form')) return;
      var form = event.target.closest('form.artmere-cart-capture-form');
      if (form.getAttribute('data-artmere-measurement-invalid-pending') === 'true') return;
      form.setAttribute('data-artmere-measurement-invalid-pending', 'true');
      var failureToken = measurementEventId();
      setTimeout(function() {
        form.removeAttribute('data-artmere-measurement-invalid-pending');
      }, 250);
      readMeasurementCart().then(function(cart) {
        publishMeasurementEvent(
          'artmere_missing_middle_save_failure',
          cart,
          { surface: 'cart_save', failure_type: 'client_validation' },
          measurementDedupKey('save_failure', cart, 'cart_save', failureToken)
        );
      }).catch(function() {});
    }, true);

    var params = new URLSearchParams(window.location.search || '');
    if (params.get('cart_capture') === 'saved' || params.get('customer_posted') === 'true' || params.get('contact_posted') === 'true') {
      readMeasurementCart().then(function(cart) {
        var returnToken = recentCaptureSubmitToken();
        if (!returnToken) return;
        publishMeasurementEvent(
          'artmere_missing_middle_save_success',
          cart,
          { surface: 'cart_save' },
          measurementDedupKey('save_success', cart, 'cart_save', returnToken)
        );
      }).catch(function() {});
    }

    window.addEventListener('ajaxCart', function() {
      setTimeout(function() {
        if (cartSurface() === 'cart_drawer') publishCartView('cart_drawer');
      }, 300);
    });

  }

  function searchV2ItemFromCard(card, fallbackIndex) {
    if (!card) return null;
    var href = card.getAttribute('href') || '';
    var item = {
      item_id: boundedMeasurementValue(card.getAttribute('data-item-id'), 80),
      item_variant: boundedMeasurementValue(card.getAttribute('data-item-variant-id'), 80),
      item_name: boundedMeasurementValue(card.getAttribute('data-item-name'), 160),
      item_list_id: boundedMeasurementValue(card.getAttribute('data-item-list-id') || 'abstract_search_v2', 80),
      item_list_name: boundedMeasurementValue(card.getAttribute('data-item-list-name') || 'Original Abstract Paintings', 160),
      index: Number(card.getAttribute('data-item-index') || fallbackIndex || 1),
      price: Number(card.getAttribute('data-item-price') || 0),
      currency: boundedMeasurementValue(card.getAttribute('data-item-currency') || 'USD', 12),
      destination_path: boundedMeasurementValue(href, 240)
    };
    if (!item.item_id || !item.item_name || !href) return null;
    return item;
  }

  function initSearchV2Measurement() {
    var root = document.querySelector('.artmere-search-v2');
    if (!root || window.__artmereSearchV2MeasurementInitialized) return;
    window.__artmereSearchV2MeasurementInitialized = true;
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-artmere-search-v2-item]'));
    var items = cards.map(function(card, index) {
      return searchV2ItemFromCard(card, index + 1);
    }).filter(Boolean);
    if (!items.length) return;
    whenMeasurementTransportReady(function() {
      publishMeasurementEvent(
        'view_item_list', {},
        { surface: 'abstract_search_v2', item_list_id: 'abstract_search_v2', item_list_name: 'Original Abstract Paintings', item_count: items.length, ecommerce: { item_list_id: 'abstract_search_v2', item_list_name: 'Original Abstract Paintings', items: items } },
        measurementDedupKey('view_item_list', {}, 'abstract_search_v2', measurementEventId())
      );
    });
    root.addEventListener('click', function(event) {
      var card = event.target && event.target.closest ? event.target.closest('[data-artmere-search-v2-item]') : null;
      if (!card || !root.contains(card)) return;
      var item = searchV2ItemFromCard(card, 1);
      if (!item) return;
      var selectedAt = new Date().toISOString();
      try { sessionStorage.setItem(SEARCH_V2_SELECTION_STORAGE_KEY, JSON.stringify({ selected_at: selectedAt, item: item })); } catch(e) {}
      publishMeasurementEvent(
        'select_item', {},
        { surface: 'abstract_search_v2', item_list_id: item.item_list_id, item_list_name: item.item_list_name, selected_item_id: item.item_id, selected_item_name: item.item_name, destination_path: item.destination_path, ecommerce: { item_list_id: item.item_list_id, item_list_name: item.item_list_name, items: [item] } },
        measurementDedupKey('select_item', {}, 'abstract_search_v2', selectedAt + ':' + item.item_id)
      );
    }, true);
  }

  function publishSearchV2PdpBridge() {
    var selection;
    try { selection = JSON.parse(sessionStorage.getItem(SEARCH_V2_SELECTION_STORAGE_KEY) || 'null'); } catch(e) { selection = null; }
    if (!selection || !selection.item || !selection.selected_at) return;
    var selectedAt = Date.parse(selection.selected_at);
    if (!selectedAt || Date.now() - selectedAt > 30 * 60 * 1000) {
      try { sessionStorage.removeItem(SEARCH_V2_SELECTION_STORAGE_KEY); } catch(e) {}
      return;
    }
    var expectedPath;
    try { expectedPath = new URL(selection.item.destination_path, window.location.origin).pathname.replace(/\/$/, ''); } catch(e) { expectedPath = ''; }
    if (!expectedPath || window.location.pathname.replace(/\/$/, '') !== expectedPath) return;
    whenMeasurementTransportReady(function() {
      var published = publishMeasurementEvent(
        'artmere_collection_to_pdp', {},
        { surface: 'product_page', source_list_id: selection.item.item_list_id, source_list_name: selection.item.item_list_name, selected_item_id: selection.item.item_id, selected_item_name: selection.item.item_name, selected_item_index: selection.item.index, selected_at: selection.selected_at, ecommerce: { items: [selection.item] } },
        measurementDedupKey('collection_to_pdp', {}, 'product_page', selection.selected_at + ':' + selection.item.item_id)
      );
      if (published) {
        try { sessionStorage.removeItem(SEARCH_V2_SELECTION_STORAGE_KEY); } catch(e) {}
      }
    });
  }


  function addCartSupportStyles() {
    if (document.querySelector('style[data-artmere-cart-support-style]')) return;
    var style = document.createElement('style');
    style.setAttribute('data-artmere-cart-support-style', 'true');
    style.textContent = [
      '.artmere-cart-safety-note{margin:10px 0 12px;padding:10px 12px;border:1px solid rgba(71,109,78,.18);border-radius:4px;background:rgba(71,109,78,.06);color:rgba(29,33,27,.78);font-size:12px;line-height:1.42;}',
      '.artmere-cart-safety-note strong{display:block;margin:0 0 2px;color:#171a15;font-size:12px;line-height:1.35;font-weight:600;}',
      '.artmere-cart-safety-note p{margin:0;color:inherit;font-size:inherit;line-height:inherit;}',
      '.m6pn .artmere-cart-safety-note{margin:10px 0 12px;}',
      '@media(max-width:749px){.artmere-cart-safety-note{margin:9px 0 11px;padding:10px;font-size:11px;}}'
    ].join('\n');
    document.head.appendChild(style);
  }

  function cartSafetyLabels(context) {
    if (isGermanPage()) {
      if (context === 'drawer') {
        return {
          title: 'Vor dem Checkout',
          text: 'Nutze Warenkorb ansehen, um Details vor dem Checkout zu prüfen. Zahlarten werden unten angezeigt.'
        };
      }
      return {
        title: 'Vor dem Checkout',
        text: 'Prüfe deinen Warenkorb zuerst. Du kannst die Auswahl außerdem per E-Mail speichern, bevor du weitergehst.'
      };
    }

    if (context === 'drawer') {
      return {
        title: 'Before checkout',
        text: 'Use View cart to review details before checkout. Payment methods are shown below.'
      };
    }
    return {
      title: 'Before checkout',
      text: 'Review your cart first. You can also save this selection by email before you continue.'
    };
  }

  function createCartSafetyNote(context) {
    var copy = cartSafetyLabels(context);
    var note = document.createElement('div');
    note.className = 'artmere-cart-safety-note';
    note.setAttribute('role', 'note');
    note.setAttribute('data-artmere-cart-safety-note', context);
    note.innerHTML = '<strong>' + escapeBasicHtml(copy.title) + '</strong><p>' + escapeBasicHtml(copy.text) + '</p>';
    return note;
  }

  function escapeBasicHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function placeCartSafetyNote(parent, anchor, context) {
    if (!parent || !anchor || !anchor.parentNode) return;
    var existing = parent.querySelector('[data-artmere-cart-safety-note="' + context + '"]');
    if (existing && existing.previousElementSibling === anchor) return;
    if (!existing) existing = createCartSafetyNote(context);
    anchor.parentNode.insertBefore(existing, anchor.nextSibling);
  }

  function initCartSafetyNotes() {
    addCartSupportStyles();

    function renderSafetyNotes() {
      var cartAside = document.querySelector('article.form-cart aside') ||
        document.querySelector('.form-cart aside');
      if (cartAside) {
        var checkoutForm = cartAside.querySelector('form.f8vl[action*="/cart"]') ||
          cartAside.querySelector('form[action*="/cart"][method="post"]');
        placeCartSafetyNote(cartAside, checkoutForm, 'cart');
      }

      var sideCart = document.getElementById('cart');
      if (sideCart && sideCart.querySelector('[data-totalqty]')) {
        var panelForm = sideCart.querySelector('.sticky-in-panel form.f8vl');
        placeCartSafetyNote(sideCart, panelForm, 'drawer');
      }
    }

    renderSafetyNotes();
    window.addEventListener('listCart', renderSafetyNotes);
    window.addEventListener('themeCartOpened', renderSafetyNotes);
    window.addEventListener('ajaxCart', renderSafetyNotes);
    setTimeout(renderSafetyNotes, 600);
    setTimeout(renderSafetyNotes, 1800);
  }

  // Parse "Small: 12x22"", "12×22"" or "Small: 30×56 cm / Frame".
  function parseSizeText(text) {
    text = text.trim();
    var suffix = '';
    var suffixMatch = text.match(/(\s+\/\s+.+)$/);
    if (suffixMatch) {
      suffix = suffixMatch[1];
      text = text.slice(0, -suffix.length).trim();
    }
    // Match patterns like "Label: WxH"" or "WxH""
    var match = text.match(/^(.*?):\s*(\d+(?:\.\d+)?)\s*[x×]\s*(\d+(?:\.\d+)?)\s*(?:"|″|in|inch|inches)?\s*$/i);
    if (match) {
      return { label: match[1].trim(), w: parseFloat(match[2]), h: parseFloat(match[3]), unit: 'in', suffix: suffix };
    }
    // Try without label
    match = text.match(/^(\d+(?:\.\d+)?)\s*[x×]\s*(\d+(?:\.\d+)?)\s*(?:"|″|in|inch|inches)?\s*$/i);
    if (match) {
      return { label: '', w: parseFloat(match[1]), h: parseFloat(match[2]), unit: 'in', suffix: suffix };
    }
    // Try cm format: "Label: 30x56 cm"
    match = text.match(/^(.*?):\s*(\d+(?:\.\d+)?)\s*[x×]\s*(\d+(?:\.\d+)?)\s*cm\s*$/i);
    if (match) {
      return { label: match[1].trim(), w: parseFloat(match[2]), h: parseFloat(match[3]), unit: 'cm', suffix: suffix };
    }
    match = text.match(/^(\d+(?:\.\d+)?)\s*[x×]\s*(\d+(?:\.\d+)?)\s*cm\s*$/i);
    if (match) {
      return { label: '', w: parseFloat(match[1]), h: parseFloat(match[2]), unit: 'cm', suffix: suffix };
    }
    return null;
  }

  function formatSize(parsed, targetUnit) {
    var w = parsed.w, h = parsed.h;
    if (parsed.unit === 'in' && targetUnit === 'cm') {
      w = Math.round(w * INCH_TO_CM);
      h = Math.round(h * INCH_TO_CM);
    } else if (parsed.unit === 'cm' && targetUnit === 'in') {
      w = Math.round(w / INCH_TO_CM);
      h = Math.round(h / INCH_TO_CM);
    }
    var suffix = targetUnit === 'cm' ? ' cm' : '"';
    var prefix = parsed.label ? parsed.label + ': ' : '';
    return prefix + w + '×' + h + suffix + (parsed.suffix || '');
  }

  function initSizeToggle() {
    // Avoid double-insertion if the poller calls this again after success
    if (document.querySelector('.artmere-unit-toggle')) return;

    // Swatch King app renders size options as:
    //   span.swatch-option-name  ("Size" heading)
    //   .swatch-button-title-text > span  (each size label)
    // These may load after DOMContentLoaded, so we retry.
    var sizeElements = []; // { element, parsed }
    var headingLabel = null;

    // Find the visible "Size" swatch heading (skip visually-hidden duplicates)
    document.querySelectorAll('label.swatch-label .swatch-option-name').forEach(function(span) {
      var headText = span.textContent.trim();
      if ((headText === 'Size' || headText === 'Größe' || headText === 'Groesse') && !headingLabel) {
        headingLabel = span.closest('label.swatch-label');
      }
    });

    // Find each visible swatch size text span
    if (headingLabel) {
      var optionContainer = headingLabel.closest('#swatch-option1, .swatch-single')
        || headingLabel.closest('[id^="swatch-option"]')
        || headingLabel.parentElement;
      if (optionContainer) {
        optionContainer.querySelectorAll('.swatch-button-title-text span').forEach(function(span) {
          var text = span.textContent.trim();
          var parsed = parseSizeText(text);
          if (parsed) {
            sizeElements.push({ element: span, originalText: text, parsed: parsed });
          }
        });
      }
    }

    // Fallback: also check native radios (themes without Swatch King)
    if (sizeElements.length === 0) {
      document.querySelectorAll('input[type="radio"][name*="options["]').forEach(function(radio) {
        var val = radio.value || '';
        var parsed = parseSizeText(val);
        if (parsed) {
          var li = radio.closest('li');
          var label = li ? li.querySelector('label') : null;
          if (label) {
            var span = label.querySelector('span');
            sizeElements.push({ element: span || label, originalText: val, parsed: parsed });
          }
          if (!headingLabel) {
            var ul = radio.closest('ul');
            var prev = ul ? ul.previousElementSibling : null;
            if (prev && prev.tagName === 'LABEL') headingLabel = prev;
          }
        }
      });
    }

    if (sizeElements.length === 0 || !headingLabel) return;

    var currentUnit = getStoredUnit();

    // Inject style to kill Swatch King's ::before pseudo-element on our buttons
    if (!document.getElementById('artmere-toggle-fix')) {
      var fix = document.createElement('style');
      fix.id = 'artmere-toggle-fix';
      fix.textContent = '.artmere-unit-toggle .unit-btn::before,.artmere-unit-toggle .unit-btn::after{display:none !important;content:none !important;}.swatch-button-title-text,.swatch-button-title-text span{font-family:Inter,sans-serif !important;}';
      document.head.appendChild(fix);
    }

    // Create toggle button next to "Size" heading
    var toggle = document.createElement('span');
    toggle.className = 'artmere-unit-toggle';
    toggle.setAttribute('style', 'display:inline-flex;gap:8px;margin-left:14px;vertical-align:middle;align-items:center;');
    toggle.innerHTML =
      '<button type="button" class="unit-btn unit-in" data-unit="in">in</button>' +
      '<button type="button" class="unit-btn unit-cm" data-unit="cm">cm</button>';

    // Insert after the heading span
    var sizeSpan = headingLabel.querySelector('.swatch-option-name') || headingLabel.querySelector('span');
    if (sizeSpan) {
      sizeSpan.insertAdjacentElement('afterend', toggle);
    } else {
      headingLabel.appendChild(toggle);
    }

    toggle.querySelectorAll('.unit-btn').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        currentUnit = this.getAttribute('data-unit');
        storeUnit(currentUnit);
        updateAllSizes();
        updateToggleState();
      });
    });

    function applyStyles(el, styles) {
      for (var prop in styles) {
        el.style.setProperty(prop, styles[prop], prop === 'letter-spacing' ? '' : 'important');
      }
    }
    var BASE_PROPS = {border:'1px solid #d0d0d0',padding:'9px 10px','font-size':'13px',cursor:'pointer','font-family':'inherit','line-height':'13px',height:'auto','min-height':'0','max-height':'none',width:'auto','min-width':'0','border-radius':'3px','letter-spacing':'.2px','font-weight':'400','text-transform':'lowercase','box-sizing':'border-box',margin:'0',display:'inline-block','text-align':'center','box-shadow':'none',outline:'none','text-decoration':'none','-webkit-appearance':'none',appearance:'none',transition:'all .2s ease'};
    var ACTIVE_EXTRA = {background:'#222',color:'#fff','border-color':'#222'};
    var INACTIVE_EXTRA = {background:'#fff',color:'#222','border-color':'#d0d0d0'};

    function updateToggleState() {
      toggle.querySelectorAll('.unit-btn').forEach(function(btn) {
        btn.removeAttribute('style');
        applyStyles(btn, BASE_PROPS);
        if (btn.getAttribute('data-unit') === currentUnit) {
          btn.classList.add('active');
          applyStyles(btn, ACTIVE_EXTRA);
        } else {
          btn.classList.remove('active');
          applyStyles(btn, INACTIVE_EXTRA);
        }
      });
    }

    function updateAllSizes() {
      sizeElements.forEach(function(item) {
        var newText = formatSize(item.parsed, currentUnit);
        item.element.textContent = newText;
      });
      updateStickyBar();
    }

    function updateStickyBar() {
      document.querySelectorAll('form h2 span, form h3 span').forEach(function(span) {
        var text = span.textContent;
        var parsed = parseSizeText(text);
        if (parsed) {
          span.textContent = formatSize(parsed, currentUnit);
        }
      });
    }

    // Initial update
    updateAllSizes();
    updateToggleState();

    // Watch for variant changes in sticky bar
    var observer = new MutationObserver(function() {
      setTimeout(updateStickyBar, 100);
    });
    document.querySelectorAll('form h2, form h3').forEach(function(el) {
      observer.observe(el, { childList: true, subtree: true, characterData: true });
    });
  }

  /* ============================================================
   * PRODUCT TITLE FIX
   * Swatch King overwrites H1 with variant title on German pages.
   * We preserve the original product title from server HTML.
   * ============================================================ */
  function initTitleFix() {
    var h1 = document.querySelector('h1.mob-h1, h1.mob-h2, h1.mob-h3');
    if (!h1) return;

    // Store original server-rendered title (before Swatch King modifies it)
    var originalTitle = h1.textContent.trim();

    // If already modified (page loaded with variant param), fetch clean title
    if (originalTitle.includes(' - ') && originalTitle.includes(':')) {
      // Title looks like "Flourish - Klein: 30×60 cm - Black Metal"
      // Extract just the product name (first part before " - ")
      originalTitle = originalTitle.split(' - ')[0].trim();
    }

    // Watch for changes and revert
    var titleObserver = new MutationObserver(function() {
      var currentText = h1.textContent.trim();
      if (currentText !== originalTitle && currentText.includes(' - ')) {
        h1.textContent = originalTitle;
      }
    });

    titleObserver.observe(h1, { childList: true, subtree: true, characterData: true });
  }

  /* ============================================================
   * LANGUAGE ↔ CURRENCY AUTO-SYNC
   * German ↔ EUR, English ↔ USD (bidirectional)
   * ============================================================ */
  function initLocaleSync() {
    if (window.__artmereLocaleSyncLoaded) return;
    window.__artmereLocaleSyncLoaded = true;

    var LOCALE_TO_COUNTRY = { 'de': 'DE', 'en': 'US' };
    var COUNTRY_TO_LOCALE = { 'DE': 'de', 'US': 'en', 'GB': 'en', 'CA': 'en' };

    function submitSyncedLocalization(form, locale, country) {
      var localeInput = form.querySelector('input[name="locale_code"]');
      var countryInput = form.querySelector('input[name="country_code"]');
      var returnToInput = form.querySelector('input[name="return_to"]');
      if (!localeInput || !countryInput) return false;

      localeInput.value = locale;
      countryInput.value = country;
      if (returnToInput) returnToInput.value = window.location.pathname + window.location.search;
      form.submit();
      return true;
    }

    function getCurrentLocale() {
      if (window.location.pathname.indexOf('/de') === 0) return 'de';
      if (window.Shopify && Shopify.locale) return Shopify.locale;
      if (document.documentElement.lang) return document.documentElement.lang.slice(0, 2).toLowerCase();
      return 'en';
    }

    function getCurrentCountry() {
      if (window.Shopify && Shopify.country) return Shopify.country;
      var countryInput = document.querySelector('.localization-form input[name="country_code"]');
      return countryInput ? countryInput.value : '';
    }

    // Capture-phase handler runs BEFORE the theme's existing handler
    document.addEventListener('click', function(e) {
      var link = e.target.closest('.localization-form a[data-value]');
      if (!link) return;

      var form = link.closest('form');
      if (!form) return;

      var value = link.getAttribute('data-value');
      var localeInput = form.querySelector('input[name="locale_code"]');
      var countryInput = form.querySelector('input[name="country_code"]');
      if (!localeInput || !countryInput) return;

      // Detect: lowercase value = locale switch, uppercase = country switch
      var isLocaleSwitch = (value === value.toLowerCase());
      var isCountrySwitch = (value === value.toUpperCase() && value.length === 2);

      if (isLocaleSwitch) {
        // Language switch: also update currency
        var targetCountry = LOCALE_TO_COUNTRY[value];
        if (targetCountry) {
          e.preventDefault();
          e.stopImmediatePropagation();
          submitSyncedLocalization(form, value, targetCountry);
        }
      } else if (isCountrySwitch) {
        // Currency switch: also update language
        var targetLocale = COUNTRY_TO_LOCALE[value];
        if (targetLocale) {
          e.preventDefault();
          e.stopImmediatePropagation();
          submitSyncedLocalization(form, targetLocale, value);
        }
      }
    }, true); // true = capture phase

    // Keep automatic page-load sync disabled. Deep links must not trigger
    // client-side localization form submissions because that reloads product
    // pages and duplicates CSS, fonts, scripts and image requests.
  }

  /* ============================================================
   * AUTO-REDIRECT BY BROWSER LANGUAGE OR GEOLOCATION
   * German browser OR German IP → /de/, only on first visit
   * ============================================================ */
  function initAutoRedirect() {
    // Only redirect on the root landing page. Deep links must render directly
    // without a client-side bounce between locale paths.
    var path = window.location.pathname;
    if (path.indexOf('/de') === 0) return;
    if (path !== '/' && path !== '') return;

    // Only redirect once per session (don't loop)
    var REDIRECT_KEY = 'artmere_lang_redirected';
    try {
      if (sessionStorage.getItem(REDIRECT_KEY)) return;
      sessionStorage.setItem(REDIRECT_KEY, '1');
    } catch(e) { return; }

    var shouldRedirect = false;

    // Check 1: Browser language is German
    var lang = (navigator.language || navigator.userLanguage || '').toLowerCase();
    if (lang.indexOf('de') === 0) shouldRedirect = true;

    // Check 2: Shopify detected country is DE (IP geolocation)
    if (!shouldRedirect) {
      var countryInput = document.querySelector('.localization-form input[name="country_code"]');
      var country = countryInput ? countryInput.value : '';
      if (country === 'DE') shouldRedirect = true;
    }

    if (shouldRedirect) {
      var targetUrl = new URL(window.location.href);
      targetUrl.pathname = '/de/';
      targetUrl.searchParams.set('country', 'DE');
      window.location.replace(targetUrl.pathname + targetUrl.search + targetUrl.hash);
    }
  }

  function getCollectorCreditLocaleTag() {
    if (window.location.pathname.indexOf('/de') === 0) return 'de';
    var lang = (document.documentElement.lang || '').toLowerCase().split('-')[0];
    return String(lang || 'en').replace(/[^a-z0-9]+/g, '_') || 'en';
  }

  function getCollectorCreditTags(source, baseTags) {
    var tags = String(baseTags || '')
      .split(',')
      .map(function(tag) { return tag.trim(); })
      .filter(Boolean);
    [
      'collector_credit',
      'collector_credit_100_usd',
      'collector_credit_min_800_usd',
      'private_offer_collector_credit_v0',
      'artmere_private_offer_requested',
      'form_subscriber',
      'locale_' + getCollectorCreditLocaleTag()
    ].forEach(function(tag) {
      if (tags.indexOf(tag) === -1) tags.push(tag);
    });
    if (source && tags.indexOf('source_' + source) === -1) {
      tags.push('source_' + source);
    }
    return tags;
  }

  function getCollectorCreditProps(source, extraProps) {
    var attribution = getMarketingAttribution();
    var params = new URLSearchParams(window.location.search || '');
    var props = {
      private_offer_type: 'collector_credit_v0',
      private_offer_code: COLLECTOR_CREDIT_CODE,
      private_offer_amount: COLLECTOR_CREDIT_AMOUNT,
      private_offer_minimum: COLLECTOR_CREDIT_MINIMUM,
      private_offer_currency: COLLECTOR_CREDIT_CURRENCY,
      private_offer_source: source || 'site',
      locale: getCollectorCreditLocaleTag(),
      page_path: window.location.pathname,
      page_url: window.location.href
    };

    ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'].forEach(function(key) {
      var value = attribution[key] || params.get(key);
      if (value) props[key] = String(value).slice(0, 120);
    });
    if (attribution.fbclid || params.get('fbclid')) props.click_id_meta = true;
    if (attribution.gclid || params.get('gclid')) props.click_id_google = true;

    extraProps = extraProps || {};
    Object.keys(extraProps).forEach(function(key) {
      props[key] = extraProps[key];
    });
    return props;
  }

  function pushCollectorCreditDataLayer(source, extraProps) {
    try {
      window.dataLayer = window.dataLayer || [];
      var props = getCollectorCreditProps(source, extraProps);
      props.event = 'artmere_private_offer_request';
      window.dataLayer.push(props);
    } catch(e) {}
  }

  function trackOmnisendCollectorCreditEvent(email, source, baseTags, extraProps) {
    try {
      if (!email || !window.omnisend || typeof window.omnisend.push !== 'function') return false;
      var tags = getCollectorCreditTags(source, baseTags);
      window.omnisend.push([
        'track',
        COLLECTOR_CREDIT_EVENT,
        {
          origin: 'api',
          properties: getCollectorCreditProps(source, extraProps),
          contact: {
            email: email,
            tags: tags
          }
        }
      ]);
      return true;
    } catch(e) {
      return false;
    }
  }

  function initCollectorCreditSignupTracking() {
    var forms = document.querySelectorAll('#atelier-newsletter-form, form[data-artmere-collector-credit-form]');
    if (!forms.length) return;

    forms.forEach(function(form) {
      if (form.getAttribute('data-artmere-collector-credit-bound') === 'true') return;
      form.setAttribute('data-artmere-collector-credit-bound', 'true');

      var source = form.getAttribute('data-artmere-collector-credit-source') || 'footer';
      var tagsInput = form.querySelector('input[name="contact[tags]"]');
      if (tagsInput) {
        tagsInput.value = getCollectorCreditTags(source, tagsInput.value).join(',');
      }

      form.addEventListener('submit', function(event) {
        if (form.getAttribute('data-artmere-submitting') === 'true') return;
        var emailInput = form.querySelector('input[name="contact[email]"], input[type="email"]');
        var email = emailInput ? String(emailInput.value || '').trim() : '';
        var currentTags = tagsInput ? tagsInput.value : '';
        pushCollectorCreditDataLayer(source, { form_id: form.id || '' });
        var tracked = trackOmnisendCollectorCreditEvent(email, source, currentTags, { form_id: form.id || '' });
        if (tracked) {
          event.preventDefault();
          form.setAttribute('data-artmere-submitting', 'true');
          setTimeout(function() {
            form.submit();
          }, 180);
        }
      });
    });
  }

  /* ============================================================
   * OMNISEND FORM TRANSLATION (German)
   * Omnisend popups/forms are English-only; translate on /de/ pages
   * ============================================================ */
  function initOmnisendTranslation() {
    if (window.location.pathname.indexOf('/de') !== 0) return;

    var translations = {
      'Join The Community': 'Werde Teil der Community',
      'And get a $50 Voucher for your first order.': 'Sichere dir einen 50\u20AC Gutschein f\u00FCr deine erste Bestellung.',
      'SUBSCRIBE': 'ANMELDEN',
      'Something went wrong!': 'Etwas ist schiefgelaufen!',
      "You're all signed up!": 'Du bist angemeldet!',
      "You'll start to receive discounts by email.": 'Du erh\u00E4ltst ab jetzt Rabatte per E-Mail.',
      'You are already subscribed': 'Du bist bereits angemeldet',
      'GET A $50 VOUCHER': 'SICHERE DIR EINEN 50\u20AC GUTSCHEIN',
      'Join us for early access to new works and studio stories.': 'Erhalte fr\u00FChen Zugang zu neuen Werken und Studio-Geschichten.',
      'THANKS FOR SIGNING UP!': 'DANKE F\u00DCR DEINE ANMELDUNG!',
      'As a thank you you\'ll find a 50$ Voucher in your inbox.': 'Als Dankesch\u00F6n findest du einen 50\u20AC Gutschein in deinem Postfach.',
      'Claim Your Welcome Gift': 'Sichere dir dein Willkommensgeschenk',
      'Use this code at checkout:': 'Verwende diesen Code beim Checkout:',
      'CONTINUE SHOPPING': 'WEITER EINKAUFEN',
      'No, thanks': 'Nein, danke',
      'No Thanks': 'Nein, danke',
      'Thank you!': 'Vielen Dank!'
    };

    var placeholderTranslations = {
      'Enter your email': 'E-Mail-Adresse eingeben',
      'Email': 'E-Mail',
      'email': 'E-Mail',
      'Your email': 'Deine E-Mail',
      'Enter email': 'E-Mail eingeben'
    };

    function translateOmnisend() {
      document.querySelectorAll('[class*="omnisend-form"]').forEach(function(el) {
        var text = el.textContent.trim();
        // Match elements by their text content (works for leaf and wrapper nodes)
        if (translations[text]) {
          // Find the deepest text-bearing child to preserve structure
          var target = el;
          while (target.children.length === 1 && target.firstElementChild.textContent.trim() === text) {
            target = target.firstElementChild;
          }
          target.textContent = translations[text];
        }
        // Translate placeholders on inputs
        if (el.tagName === 'INPUT' && el.placeholder && placeholderTranslations[el.placeholder]) {
          el.placeholder = placeholderTranslations[el.placeholder];
        }
      });
      document.querySelectorAll('[class*="omnisend"] input[placeholder]').forEach(function(inp) {
        if (placeholderTranslations[inp.placeholder]) {
          inp.placeholder = placeholderTranslations[inp.placeholder];
        }
      });
    }

    // Run immediately and watch for new Omnisend elements (popups load lazily)
    translateOmnisend();
    var omnisendObserver = new MutationObserver(function() {
      translateOmnisend();
    });
    omnisendObserver.observe(document.body, { childList: true, subtree: true });
  }

  /* ============================================================
   * OMNISEND PDP / CART OVERLAY GUARD
   * Keep paid PDP traffic focused and let the cart use Artmere's
   * own intent-specific capture instead of the generic voucher popup.
   * ============================================================ */
  function initOmnisendPdpGuard() {
    var normalizedPath = window.location.pathname.replace(/^\/de(?=\/|$)/, '') || '/';
    var isProductPage = normalizedPath.indexOf('/products/') !== -1;
    var isCartPage = normalizedPath === '/cart';
    if (!isProductPage && !isCartPage) return;

    var guardStyle = document.createElement('style');
    guardStyle.setAttribute('data-artmere-omnisend-pdp-guard', 'true');
    guardStyle.textContent = [
      '[class*="omnisend-form-"][class*="-container"],',
      '[class*="omnisend-form-"][class*="-overlay"],',
      '[class*="omnisend-reset-"][class*="omnisend-form-"] {',
      '  display: none !important;',
      '  visibility: hidden !important;',
      '  opacity: 0 !important;',
      '  pointer-events: none !important;',
      '}'
    ].join('\n');
    document.head.appendChild(guardStyle);

    function removeOmnisendPopups() {
      var selectors = [
        '[class*="omnisend-form-"][class*="-container"]',
        '[class*="omnisend-reset-"][class*="omnisend-form-"]'
      ];
      document.querySelectorAll(selectors.join(',')).forEach(function(el) {
        el.remove();
      });

      if (document.body && document.body.style.overflow === 'hidden') {
        document.body.style.overflow = '';
      }
      if (document.documentElement && document.documentElement.style.overflow === 'hidden') {
        document.documentElement.style.overflow = '';
      }
    }

    removeOmnisendPopups();
    var pdpGuardObserver = new MutationObserver(removeOmnisendPopups);
    pdpGuardObserver.observe(document.documentElement, { childList: true, subtree: true });
  }

  /* ============================================================
   * CART SAVE CAPTURE
   * Inline Shopify customer form for cart visitors. These contacts sync
   * into Omnisend through the existing Shopify app integration.
   * ============================================================ */
  function initCartSaveCapture() {
    var normalizedPath = window.location.pathname.replace(/^\/de(?=\/|$)/, '') || '/';
    if (normalizedPath !== '/cart') return;
    if (document.querySelector('[data-artmere-cart-capture]')) return;

    function isGerman() {
      return isGermanPage();
    }

    function getRoute(path) {
      var root = '/';
      try {
        if (window.Shopify && Shopify.routes && Shopify.routes.root) {
          root = Shopify.routes.root;
        }
      } catch(e) {}
      return root.replace(/\/?$/, '/') + String(path || '').replace(/^\//, '');
    }

    function escapeHtml(value) {
      return String(value == null ? '' : value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
    }

    function sanitizeTag(value) {
      return String(value || '')
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '_')
        .replace(/^_+|_+$/g, '')
        .slice(0, 48);
    }

    function valueBucket(totalCents) {
      var total = Math.round((Number(totalCents) || 0) / 100);
      if (total >= 2000) return '2000_plus';
      if (total >= 1500) return '1500_1999';
      if (total >= 1000) return '1000_1499';
      if (total >= 500) return '500_999';
      if (total >= 1) return '1_499';
      return 'unknown';
    }

    function addTag(tags, prefix, value) {
      var tagValue = sanitizeTag(value);
      if (tagValue) tags.push(prefix + tagValue);
    }

    function getLocaleTag() {
      if (window.location.pathname.indexOf('/de') === 0) return 'de';
      var lang = (document.documentElement.lang || '').toLowerCase().split('-')[0];
      return sanitizeTag(lang || 'en') || 'en';
    }

    function getCartItemOption(item, names) {
      var wanted = names.map(function(name) { return String(name).toLowerCase(); });
      var options = item && item.options_with_values ? item.options_with_values : [];

      for (var i = 0; i < options.length; i += 1) {
        var optionName = String(options[i].name || '').toLowerCase();
        if (wanted.indexOf(optionName) !== -1 && options[i].value) {
          return options[i].value;
        }
      }
      return '';
    }

    function addAttributionTags(tags) {
      var attribution = getMarketingAttribution();
      var params = new URLSearchParams(window.location.search || '');
      ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'].forEach(function(key) {
        addTag(tags, key + '_', attribution[key] || params.get(key));
      });

      if (attribution.fbclid || params.get('fbclid')) tags.push('click_id_meta');
      if (attribution.gclid || params.get('gclid')) tags.push('click_id_google');
    }

    function buildTags(cart) {
      var currency = sanitizeTag(cart.currency || 'USD') || 'usd';
      var tags = [
        'cart_capture',
        'email_artwork_details',
        'artmere_artwork_details_cart',
        'form_subscriber',
        'source_cart',
        'locale_' + getLocaleTag(),
        'currency_' + currency,
        'cart_value_' + currency + '_' + valueBucket(cart.total_price)
      ];

      if (cart.item_count) {
        tags.push('cart_items_' + Math.min(Number(cart.item_count) || 1, 9));
      }

      (cart.items || []).slice(0, 3).forEach(function(item) {
        var handle = sanitizeTag(item.handle || item.product_handle || item.product_title);
        if (handle) tags.push('cart_product_' + handle);
        addTag(tags, 'cart_variant_', item.variant_title);
        addTag(tags, 'cart_size_', getCartItemOption(item, ['Size', 'Groesse', 'Größe']));
        addTag(tags, 'cart_finish_', getCartItemOption(item, ['Finish', 'Frame', 'Rahmen']));
        tags.push('cart_item_price_' + currency + '_' + valueBucket(item.final_price || item.price));
      });

      addAttributionTags(tags);

      return tags.join(',');
    }

    function labels() {
      if (isGerman()) {
        return {
          kicker: '',
          title: 'Kunstwerk speichern',
          text: 'Sende dir Link, gewählte Größe und Warenkorb per E-Mail.',
          placeholder: 'E-Mail-Adresse',
          button: 'Senden',
          micro: '',
          successTitle: 'Gesendet.',
          successText: 'Deine Kunstwerk-Details und der Warenkorb-Link sind in deinem Postfach.',
          successNext: 'Du kannst den Warenkorb jetzt prüfen oder direkt mit dem Checkout fortfahren.'
        };
      }
      return {
        kicker: '',
        title: 'Save your artwork',
        text: 'Email yourself the artwork link, selected size and cart.',
        placeholder: 'Email address',
        button: 'Send',
        micro: '',
        successTitle: 'Sent.',
        successText: 'Your artwork details and cart link are in your inbox.',
        successNext: 'You can review the cart now or continue to checkout when ready.'
      };
    }

    function addStyles() {
      if (document.querySelector('style[data-artmere-cart-capture-style]')) return;
      var style = document.createElement('style');
      style.setAttribute('data-artmere-cart-capture-style', 'true');
      style.textContent = [
        '.artmere-cart-capture{margin:18px 0 20px;padding:18px;border:1px solid rgba(31,35,28,.11);border-radius:6px;background:#fff;color:#1d211b;box-shadow:0 1px 0 rgba(31,35,28,.04);}',
        '.artmere-cart-capture-kicker{margin:0 0 6px;font-size:11px;line-height:1.3;letter-spacing:0;text-transform:uppercase;color:#6b7168;}',
        '.artmere-cart-capture h3{margin:0 0 6px;font-size:18px;line-height:1.22;letter-spacing:0;color:#171a15;}',
        '.artmere-cart-capture p{margin:0;color:rgba(29,33,27,.7);font-size:13px;line-height:1.42;}',
        '.artmere-cart-capture-form{margin-top:13px;}',
        '.artmere-cart-capture-row{display:flex;gap:8px;align-items:stretch;}',
        '.artmere-cart-capture-row input[type="email"]{flex:1;min-width:0;height:44px;border:1px solid rgba(31,35,28,.18);border-radius:5px;padding:0 12px;background:#fbfaf7;color:#171a15;font:inherit;font-size:14px;box-sizing:border-box;}',
        '.artmere-cart-capture-row input[type="email"]::placeholder{color:rgba(29,33,27,.45);}',
        '.artmere-cart-capture-row button{flex:0 0 78px;min-width:78px;max-width:78px;height:44px;border:0!important;border-radius:5px;padding:0 10px;background:#3f714d!important;color:#fff!important;font:inherit;font-size:12px;line-height:1.1;letter-spacing:0;white-space:nowrap;cursor:pointer;box-sizing:border-box;box-shadow:none!important;outline:none;-webkit-appearance:none;appearance:none;}',
        '.artmere-cart-capture-row button:before,.artmere-cart-capture-row button:after{display:none!important;content:none!important;}',
        '.artmere-cart-capture-row button:hover{background:#345f40!important;border-color:#345f40!important;}',
        '.artmere-cart-capture-row button:focus-visible{outline:2px solid rgba(63,113,77,.35);outline-offset:2px;}',
        '.artmere-cart-capture-micro{display:block;margin-top:8px;color:rgba(29,33,27,.58);font-size:11px;line-height:1.35;}',
        '.artmere-cart-capture-success{padding:2px 0 0;}',
        '.artmere-cart-capture-success strong{display:block;margin-bottom:4px;color:#171a15;font-size:14px;line-height:1.3;}',
        '.artmere-cart-capture-success p + p{margin-top:4px;}',
        '@media(max-width:749px){.artmere-cart-capture{padding:16px;margin:16px 0 18px}.artmere-cart-capture-row{display:block}.artmere-cart-capture-row input[type="email"],.artmere-cart-capture-row button{width:100%;min-width:0}.artmere-cart-capture-row button{flex:0 0 auto;max-width:none;margin-top:8px}}'
      ].join('\n');
      document.head.appendChild(style);
    }

    function markCaptureSubmitted() {
      try {
        sessionStorage.setItem(CART_CAPTURE_SUBMIT_KEY, '1');
        sessionStorage.setItem(CART_CAPTURE_SUBMIT_AT_KEY, String(Date.now()));
      } catch(e) {}
    }

    function hasRecentCaptureSubmit() {
      try {
        if (sessionStorage.getItem(CART_CAPTURE_SUBMIT_KEY) !== '1') return false;
        var submittedAt = Number(sessionStorage.getItem(CART_CAPTURE_SUBMIT_AT_KEY) || 0);
        if (!submittedAt) return true;
        return Date.now() - submittedAt < 10 * 60 * 1000;
      } catch(e) {
        return false;
      }
    }

    function getInsertionPoint() {
      var aside = document.querySelector('article.form-cart aside') ||
        document.querySelector('.form-cart aside');
      if (!aside) return null;
      var checkoutForm = aside.querySelector('form[action*="/cart"][method="post"]');
      var dynamicCheckout = aside.querySelector('.overlay-dynamic_buy_button');
      var trustBadge = aside.querySelector('.l4al-trustbadge');
      var paymentMethods = aside.querySelector('.l4pm');
      var sellerNotes = aside.querySelector('.input-show');
      return {
        parent: aside,
        before: dynamicCheckout || trustBadge || paymentMethods || sellerNotes || null,
        after: checkoutForm || null
      };
    }

    function pushCaptureEvent(name, cart) {
      try {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: name,
          capture_type: 'email_artwork_details',
          cart_item_count: cart.item_count || 0,
          cart_value: Math.round((Number(cart.total_price) || 0) / 100),
          currency: cart.currency || 'USD',
          cart_product_handles: (cart.items || []).slice(0, 3).map(function(item) {
            return item.handle || item.product_handle || '';
          }).filter(Boolean)
        });
      } catch(e) {}
    }

    function cartItemUrl(item) {
      var rawUrl = item && (item.url || item.product_url);
      if (rawUrl) {
        try {
          return new URL(rawUrl, window.location.origin).toString();
        } catch(e) {
          return rawUrl;
        }
      }
      var handle = item && (item.handle || item.product_handle);
      return handle ? (window.location.origin + getRoute('products/' + handle)) : window.location.origin;
    }

    function absoluteUrl(value) {
      if (!value) return '';
      var raw = String(value);
      if (raw.indexOf('//') === 0) return window.location.protocol + raw;
      try {
        return new URL(raw, window.location.origin).toString();
      } catch(e) {
        return raw;
      }
    }

    function cartItemImageUrl(item) {
      var rawImage = item && (item.image || item.featured_image || item.product_image);
      return absoluteUrl(rawImage);
    }

    function moneyFromCents(cents) {
      var amount = (Number(cents) || 0) / 100;
      if (!amount) return '0';
      return Math.round(amount) === amount ? String(Math.round(amount)) : amount.toFixed(2);
    }

    function cartItemTitle(item) {
      return (item && (item.product_title || item.title)) || 'Artwork';
    }

    function cartItemsText(cart) {
      var currency = String((cart && cart.currency) || 'USD').toUpperCase();
      var items = (cart && cart.items ? cart.items : []).slice(0, 5);
      if (!items.length) {
        return 'Open your cart to review the artwork details.';
      }

      var text = items.map(function(item, index) {
        var quantity = Math.max(1, Number(item.quantity) || 1);
        var linePrice = Number(item.final_line_price || 0);
        if (!linePrice) {
          linePrice = (Number(item.final_price || item.price) || 0) * quantity;
        }

        var details = [];
        var variant = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
        var size = getCartItemOption(item, ['Size', 'Groesse', 'Größe']);
        var finish = getCartItemOption(item, ['Finish', 'Frame', 'Rahmen']);
        if (variant) details.push('Option: ' + variant);
        if (size) details.push('Size: ' + size);
        if (finish) details.push('Finish: ' + finish);
        if (quantity > 1) details.push('Quantity: ' + quantity);
        details.push('Price in cart: ' + currency + ' ' + moneyFromCents(linePrice));
        details.push('Artwork link: ' + cartItemUrl(item));

        return (index + 1) + '. ' + cartItemTitle(item) + '\n   ' + details.join('\n   ');
      }).join('\n\n');

      var remaining = ((cart && cart.items) || []).length - items.length;
      if (remaining > 0) {
        text += '\n\n+' + remaining + ' more item' + (remaining === 1 ? '' : 's') + ' in your cart.';
      }
      return text;
    }

    function trackOmnisendArtworkEvent(email, cart, tags) {
      try {
        if (!email || !window.omnisend || typeof window.omnisend.push !== 'function') return false;
        var item = (cart.items || [])[0] || {};
        var currency = String(cart.currency || 'USD').toUpperCase();
        var cartValue = Math.round((Number(cart.total_price) || 0) / 100);
        var itemPrice = Math.round((Number(item.final_price || item.price) || 0) / 100);
        window.omnisend.push([
          'track',
          'artwork details requested',
          {
            origin: 'api',
            properties: {
              cart_capture_type: 'email_artwork_details',
              locale: getLocaleTag(),
              currency: currency,
              cart_value: String(cartValue),
              cart_items: String(Number(cart.item_count) || 0),
              cart_items_text: cartItemsText(cart),
              artwork_title: item.product_title || item.title || '',
              product_handle: item.handle || item.product_handle || '',
              product_url: cartItemUrl(item),
              cart_url: window.location.origin + getRoute('cart'),
              artwork_image_url: cartItemImageUrl(item),
              variant_title: item.variant_title || '',
              selected_size: getCartItemOption(item, ['Size', 'Groesse', 'Größe']),
              selected_finish: getCartItemOption(item, ['Finish', 'Frame', 'Rahmen']),
              item_price: String(itemPrice)
            },
            contact: {
              email: email,
              tags: String(tags || '').split(',').filter(Boolean)
            }
          }
        ]);
        return true;
      } catch(e) {
        return false;
      }
    }

    function render(cart) {
      if (!cart || Number(cart.item_count || 0) < 1) return;
      var target = getInsertionPoint();
      if (!target || !target.parent) return;

      addStyles();

      var copy = labels();
      var tags = buildTags(cart);
      var params = new URLSearchParams(window.location.search || '');
      var savedByQuery = params.get('cart_capture') === 'saved' ||
        params.get('customer_posted') === 'true' ||
        params.get('contact_posted') === 'true';
      var isCaptureHash = window.location.hash === '#artmere-cart-capture';
      var isSaved = savedByQuery || (isCaptureHash && hasRecentCaptureSubmit());
      var returnTo = window.location.pathname + '?cart_capture=saved#artmere-cart-capture';

      var panel = document.createElement('section');
      panel.className = 'artmere-cart-capture';
      panel.id = 'artmere-cart-capture';
      panel.setAttribute('data-artmere-cart-capture', 'true');

      panel.innerHTML = [
        copy.kicker ? '<p class="artmere-cart-capture-kicker">' + escapeHtml(copy.kicker) + '</p>' : '',
        '<h3>' + escapeHtml(copy.title) + '</h3>',
        '<p>' + escapeHtml(copy.text) + '</p>',
        isSaved ? [
          '<div class="artmere-cart-capture-success" role="status">',
          '<strong>' + escapeHtml(copy.successTitle) + '</strong>',
          '<p>' + escapeHtml(copy.successText) + '</p>',
          '<p>' + escapeHtml(copy.successNext) + '</p>',
          '</div>'
        ].join('') : [
          '<form method="post" action="' + escapeHtml(getRoute('contact#artmere-cart-capture')) + '" accept-charset="UTF-8" class="artmere-cart-capture-form">',
          '<input type="hidden" name="form_type" value="customer">',
          '<input type="hidden" name="utf8" value="&#10003;">',
          '<input type="hidden" name="return_to" value="' + escapeHtml(returnTo) + '">',
          '<input type="hidden" name="contact[tags]" value="' + escapeHtml(tags) + '">',
          '<input type="hidden" name="contact[accepts_marketing]" value="true">',
          '<div class="artmere-cart-capture-row">',
          '<label for="artmere-cart-capture-email" class="visually-hidden">' + escapeHtml(copy.placeholder) + '</label>',
          '<input id="artmere-cart-capture-email" type="email" name="contact[email]" placeholder="' + escapeHtml(copy.placeholder) + '" autocomplete="email" required>',
          '<button type="submit">' + escapeHtml(copy.button) + '</button>',
          '</div>',
          copy.micro ? '<span class="artmere-cart-capture-micro">' + escapeHtml(copy.micro) + '</span>' : '',
          '</form>'
        ].join('')
      ].join('');

      var form = panel.querySelector('form.artmere-cart-capture-form');
      if (form) {
        form.addEventListener('submit', function(event) {
          if (form.getAttribute('data-artmere-submitting') === 'true') return;
          var emailInput = form.querySelector('input[name="contact[email]"]');
          var email = emailInput ? String(emailInput.value || '').trim() : '';
          var tracked = trackOmnisendArtworkEvent(email, cart, tags);
          if (tracked) {
            event.preventDefault();
            form.setAttribute('data-artmere-submitting', 'true');
            setTimeout(function() {
              form.submit();
            }, 180);
          }
        });
      }

      var isPlacingPanel = false;
      function placePanel() {
        if (isPlacingPanel) return;
        var freshTarget = getInsertionPoint();
        if (!freshTarget || !freshTarget.parent) return;

        isPlacingPanel = true;
        if (freshTarget.before && freshTarget.before.parentNode === freshTarget.parent) {
          if (panel.nextElementSibling !== freshTarget.before) {
            freshTarget.parent.insertBefore(panel, freshTarget.before);
          }
        } else if (freshTarget.after && freshTarget.after.parentNode === freshTarget.parent) {
          if (panel.previousElementSibling !== freshTarget.after) {
            freshTarget.parent.insertBefore(panel, freshTarget.after.nextSibling);
          }
        } else {
          freshTarget.parent.appendChild(panel);
        }
        isPlacingPanel = false;
      }

      placePanel();
      var placementObserver = new MutationObserver(placePanel);
      placementObserver.observe(target.parent, { childList: true });
      var placementAttempts = 0;
      var placementInterval = setInterval(function() {
        placementAttempts += 1;
        placePanel();
        if (placementAttempts >= 15) {
          clearInterval(placementInterval);
          placementObserver.disconnect();
          placePanel();
        }
      }, 1000);

      var form = panel.querySelector('form');
      if (form) {
        form.addEventListener('submit', function() {
          markCaptureSubmitted();
          pushCaptureEvent('artmere_cart_capture_submit', cart);
          var button = form.querySelector('button[type="submit"]');
          if (button) {
            button.setAttribute('aria-busy', 'true');
          }
        });
      }

      pushCaptureEvent(isSaved ? 'artmere_cart_capture_success_view' : 'artmere_cart_capture_view', cart);
    }

    fetch(getRoute('cart.js'), { credentials: 'same-origin' })
      .then(function(response) {
        if (!response.ok) throw new Error('cart.js unavailable');
        return response.json();
      })
      .then(render)
      .catch(function() {
        var cartNode = document.querySelector('article.form-cart[data-totalqty]');
        var qty = cartNode ? Number(cartNode.getAttribute('data-totalqty') || 0) : 0;
        if (qty > 0) {
          render({ item_count: qty, total_price: 0, currency: 'USD', items: [] });
        }
      });
  }

  /* ============================================================
   * FOUNDER VIDEO PORTRAIT MODAL
   * Opens founder videos in a viewport-contained 9:16 player. No
   * Fullscreen API is used, and playsinline prevents forced iOS fullscreen.
   * ============================================================ */
  var activeFounderVideoModal = null;
  var founderModalReturnFocus = null;
  var founderModalPreviousBodyOverflow = '';

  function addFounderVideoModalStyles() {
    if (document.querySelector('style[data-artmere-founder-modal-style]')) return;

    var style = document.createElement('style');
    style.setAttribute('data-artmere-founder-modal-style', 'true');
    style.textContent = [
      '.artmere-founder-modal{position:fixed;inset:0;z-index:2147483000;display:grid;place-items:center;padding:16px;background:rgba(11,13,11,.82);backdrop-filter:blur(6px);-webkit-backdrop-filter:blur(6px);}',
      '.artmere-founder-modal__dialog{position:relative;width:min(520px,calc(100vw - 32px),calc((100dvh - 32px)*.5625));max-width:100%;aspect-ratio:9/16;overflow:hidden;border-radius:12px;background:#050505;box-shadow:0 24px 80px rgba(0,0,0,.48);}',
      '.artmere-founder-modal__video{display:block;width:100%;height:100%;object-fit:contain;background:#050505;cursor:pointer;}',
      '.artmere-founder-modal__controls{position:absolute;right:0;bottom:0;left:0;z-index:3;display:grid;grid-template-columns:40px 72px minmax(80px,1fr) 40px;gap:8px;align-items:center;padding:30px 10px 10px;background:linear-gradient(to bottom,transparent,rgba(0,0,0,.82));color:#fff;font:500 12px/1.2 Arial,sans-serif;}',
      '.artmere-founder-modal__control{display:grid;width:40px;height:40px;place-items:center;padding:0;border:0;border-radius:50%;background:rgba(15,15,15,.62);color:#fff;font:600 18px/1 Arial,sans-serif;cursor:pointer;}',
      '.artmere-founder-modal__control:hover,.artmere-founder-modal__control:focus-visible{background:rgba(15,15,15,.9);}',
      '.artmere-founder-modal__control:focus-visible,.artmere-founder-modal__progress:focus-visible{outline:2px solid #fff;outline-offset:2px;}',
      '.artmere-founder-modal__time{white-space:nowrap;text-align:center;font-variant-numeric:tabular-nums;}',
      '.artmere-founder-modal__progress{width:100%;height:20px;margin:0;accent-color:#fff;cursor:pointer;}',
      '.artmere-founder-modal__close{position:absolute;top:10px;right:10px;z-index:4;display:grid;width:40px;height:40px;place-items:center;padding:0;border:1px solid rgba(255,255,255,.5);border-radius:50%;background:rgba(10,10,10,.7);color:#fff;font:300 30px/1 Arial,sans-serif;cursor:pointer;box-shadow:0 4px 18px rgba(0,0,0,.24);}',
      '.artmere-founder-modal__close:hover,.artmere-founder-modal__close:focus-visible{background:rgba(10,10,10,.9);}',
      '.artmere-founder-modal__close:focus-visible{outline:2px solid #fff;outline-offset:2px;}',
      '@supports not (height:100dvh){.artmere-founder-modal__dialog{width:min(520px,calc(100vw - 32px),calc((100vh - 32px)*.5625));}}',
      '@media(max-width:749px){.artmere-founder-modal{padding:10px}.artmere-founder-modal__dialog{width:min(520px,calc(100vw - 20px),calc((100dvh - 20px)*.5625));border-radius:10px}.artmere-founder-modal__close{top:8px;right:8px;width:38px;height:38px;font-size:28px}.artmere-founder-modal__controls{grid-template-columns:40px 66px minmax(70px,1fr) 40px;gap:6px;padding:28px 8px 8px}.artmere-founder-modal__time{font-size:11px}}',
      '@media(prefers-reduced-motion:reduce){.artmere-founder-modal{backdrop-filter:none;-webkit-backdrop-filter:none;}}'
    ].join('\n');
    document.head.appendChild(style);
  }

  function closeFounderVideoModal() {
    if (!activeFounderVideoModal) return;

    var video = activeFounderVideoModal.querySelector('video');
    if (video) {
      video.pause();
      video.removeAttribute('src');
      video.load();
    }

    activeFounderVideoModal.remove();
    activeFounderVideoModal = null;
    document.body.style.overflow = founderModalPreviousBodyOverflow;

    if (founderModalReturnFocus && document.contains(founderModalReturnFocus)) {
      founderModalReturnFocus.focus();
    }
    founderModalReturnFocus = null;
  }

  function openFounderVideoModal(options, trigger) {
    if (!options || !options.src) return;

    closeFounderVideoModal();
    addFounderVideoModalStyles();

    founderModalReturnFocus = trigger || document.activeElement;
    founderModalPreviousBodyOverflow = document.body.style.overflow;

    var modal = document.createElement('div');
    modal.className = 'artmere-founder-modal';
    modal.setAttribute('data-artmere-founder-modal', 'true');

    var dialog = document.createElement('div');
    dialog.className = 'artmere-founder-modal__dialog';
    dialog.setAttribute('role', 'dialog');
    dialog.setAttribute('aria-modal', 'true');
    dialog.setAttribute('aria-label', options.label || (isGermanPage() ? 'Gründervideo' : 'Founder video'));

    var video = document.createElement('video');
    video.className = 'artmere-founder-modal__video';
    video.controls = false;
    video.playsInline = true;
    video.preload = 'metadata';
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');
    video.setAttribute('controlslist', 'nofullscreen nodownload noremoteplayback');
    video.setAttribute('disablepictureinpicture', '');
    video.setAttribute('x-webkit-airplay', 'deny');
    video.src = options.src;
    if (options.poster) video.poster = options.poster;

    var controls = document.createElement('div');
    controls.className = 'artmere-founder-modal__controls';

    var playToggle = document.createElement('button');
    playToggle.type = 'button';
    playToggle.className = 'artmere-founder-modal__control artmere-founder-modal__play';
    playToggle.setAttribute('aria-label', isGermanPage() ? 'Video abspielen' : 'Play video');
    playToggle.innerHTML = '<span aria-hidden="true">&#9654;</span>';

    var timeLabel = document.createElement('span');
    timeLabel.className = 'artmere-founder-modal__time';
    timeLabel.textContent = '0:00 / 0:00';

    var progress = document.createElement('input');
    progress.className = 'artmere-founder-modal__progress';
    progress.type = 'range';
    progress.min = '0';
    progress.max = '100';
    progress.step = '0.1';
    progress.value = '0';
    progress.setAttribute('aria-label', isGermanPage() ? 'Videoposition' : 'Video position');

    var muteToggle = document.createElement('button');
    muteToggle.type = 'button';
    muteToggle.className = 'artmere-founder-modal__control artmere-founder-modal__mute';
    muteToggle.setAttribute('aria-label', isGermanPage() ? 'Video stummschalten' : 'Mute video');
    muteToggle.innerHTML = '<span aria-hidden="true">&#128266;</span>';

    function formatVideoTime(seconds) {
      if (!Number.isFinite(seconds) || seconds < 0) return '0:00';
      var minutes = Math.floor(seconds / 60);
      var remainder = Math.floor(seconds % 60);
      return minutes + ':' + String(remainder).padStart(2, '0');
    }

    function syncFounderVideoControls() {
      var duration = Number.isFinite(video.duration) ? video.duration : 0;
      var current = Number.isFinite(video.currentTime) ? video.currentTime : 0;
      progress.value = duration > 0 ? String((current / duration) * 100) : '0';
      timeLabel.textContent = formatVideoTime(current) + ' / ' + formatVideoTime(duration);
      playToggle.innerHTML = video.paused ? '<span aria-hidden="true">&#9654;</span>' : '<span aria-hidden="true">&#10074;&#10074;</span>';
      playToggle.setAttribute('aria-label', video.paused ? (isGermanPage() ? 'Video abspielen' : 'Play video') : (isGermanPage() ? 'Video pausieren' : 'Pause video'));
      muteToggle.innerHTML = video.muted ? '<span aria-hidden="true">&#128263;</span>' : '<span aria-hidden="true">&#128266;</span>';
      muteToggle.setAttribute('aria-label', video.muted ? (isGermanPage() ? 'Ton einschalten' : 'Unmute video') : (isGermanPage() ? 'Video stummschalten' : 'Mute video'));
    }

    function toggleFounderVideoPlayback() {
      if (video.paused) {
        var pendingPlay = video.play();
        if (pendingPlay && typeof pendingPlay.catch === 'function') {
          pendingPlay.catch(function() {});
        }
      } else {
        video.pause();
      }
    }

    var close = document.createElement('button');
    close.type = 'button';
    close.className = 'artmere-founder-modal__close';
    close.setAttribute('aria-label', isGermanPage() ? 'Video schließen' : 'Close video');
    close.innerHTML = '<span aria-hidden="true">&times;</span>';

    controls.appendChild(playToggle);
    controls.appendChild(timeLabel);
    controls.appendChild(progress);
    controls.appendChild(muteToggle);

    dialog.appendChild(video);
    dialog.appendChild(controls);
    dialog.appendChild(close);
    modal.appendChild(dialog);
    document.body.appendChild(modal);
    document.body.style.overflow = 'hidden';
    activeFounderVideoModal = modal;

    close.addEventListener('click', closeFounderVideoModal);
    playToggle.addEventListener('click', toggleFounderVideoPlayback);
    video.addEventListener('click', toggleFounderVideoPlayback);
    video.addEventListener('loadedmetadata', syncFounderVideoControls);
    video.addEventListener('timeupdate', syncFounderVideoControls);
    video.addEventListener('play', syncFounderVideoControls);
    video.addEventListener('pause', syncFounderVideoControls);
    video.addEventListener('ended', syncFounderVideoControls);
    progress.addEventListener('input', function() {
      if (Number.isFinite(video.duration) && video.duration > 0) {
        video.currentTime = (Number(progress.value) / 100) * video.duration;
      }
    });
    muteToggle.addEventListener('click', function() {
      video.muted = !video.muted;
      syncFounderVideoControls();
    });
    modal.addEventListener('click', function(event) {
      if (event.target === modal) closeFounderVideoModal();
    });

    syncFounderVideoControls();
    close.focus();
    var play = video.play();
    if (play && typeof play.catch === 'function') {
      play.catch(function() {});
    }
  }

  function initFounderVideoModals() {
    document.addEventListener('click', function(event) {
      var trigger = event.target.closest('[data-artmere-founder-modal-trigger]');
      if (!trigger) return;

      event.preventDefault();
      var media = trigger.closest('figure, [data-founder-video-fallback], [class*="founder-video-media-"]');
      var preview = media ? media.querySelector('video') : null;
      var source = preview ? preview.querySelector('source') : null;
      var src = trigger.getAttribute('data-video-src') || (source ? source.getAttribute('src') : '') || (preview ? preview.currentSrc || preview.src : '');
      var poster = trigger.getAttribute('data-video-poster') || (preview ? preview.getAttribute('poster') : '');
      var label = trigger.getAttribute('data-video-label') || trigger.getAttribute('aria-label') || '';

      openFounderVideoModal({ src: src, poster: poster, label: label }, trigger);
    });

    document.addEventListener('keydown', function(event) {
      if (event.key === 'Escape' && activeFounderVideoModal) closeFounderVideoModal();
    });
  }

  /* ============================================================
   * FOUNDER VIDEO INLINE PLAYBACK (homepage "person behind ARTMERE" card)
   * Deliberately separate from data-artmere-founder-modal-trigger above:
   * this section's triggers use data-artmere-founder-inline-trigger so the
   * shared portrait modal (still used by the About page fallback) is left
   * completely untouched. Plays the existing <video> in place inside the
   * section's own media box -- no modal, no overlay, no fullscreen.
   * ============================================================ */
  function formatFounderInlineTime(seconds) {
    if (!Number.isFinite(seconds) || seconds < 0) return '0:00';
    var minutes = Math.floor(seconds / 60);
    var remainder = Math.floor(seconds % 60);
    return minutes + ':' + String(remainder).padStart(2, '0');
  }

  function buildFounderInlineControls(media, video) {
    var controls = document.createElement('div');
    controls.className = 'artmere-founder__inline-controls';

    var playToggle = document.createElement('button');
    playToggle.type = 'button';
    playToggle.className = 'artmere-founder__inline-control artmere-founder__inline-play';

    var progress = document.createElement('input');
    progress.type = 'range';
    progress.className = 'artmere-founder__inline-progress';
    progress.min = '0';
    progress.max = '100';
    progress.step = '0.1';
    progress.value = '0';
    progress.setAttribute('aria-label', isGermanPage() ? 'Videoposition' : 'Video position');

    var muteToggle = document.createElement('button');
    muteToggle.type = 'button';
    muteToggle.className = 'artmere-founder__inline-control artmere-founder__inline-mute';

    function sync() {
      var duration = Number.isFinite(video.duration) ? video.duration : 0;
      var current = Number.isFinite(video.currentTime) ? video.currentTime : 0;
      progress.value = duration > 0 ? String((current / duration) * 100) : '0';
      progress.setAttribute(
        'aria-valuetext',
        formatFounderInlineTime(current) + ' / ' + formatFounderInlineTime(duration)
      );
      playToggle.innerHTML = video.paused ? '<span aria-hidden="true">&#9654;</span>' : '<span aria-hidden="true">&#10074;&#10074;</span>';
      playToggle.setAttribute('aria-label', video.paused ? (isGermanPage() ? 'Video abspielen' : 'Play video') : (isGermanPage() ? 'Video pausieren' : 'Pause video'));
      muteToggle.innerHTML = video.muted ? '<span aria-hidden="true">&#128263;</span>' : '<span aria-hidden="true">&#128266;</span>';
      muteToggle.setAttribute('aria-label', video.muted ? (isGermanPage() ? 'Ton einschalten' : 'Unmute video') : (isGermanPage() ? 'Video stummschalten' : 'Mute video'));
    }

    playToggle.addEventListener('click', function() {
      if (video.paused) {
        var pending = video.play();
        if (pending && typeof pending.catch === 'function') pending.catch(function() {});
      } else {
        video.pause();
      }
    });
    muteToggle.addEventListener('click', function() {
      video.muted = !video.muted;
      sync();
    });
    progress.addEventListener('input', function() {
      if (Number.isFinite(video.duration) && video.duration > 0) {
        video.currentTime = (Number(progress.value) / 100) * video.duration;
      }
    });
    video.addEventListener('timeupdate', sync);
    video.addEventListener('play', sync);
    video.addEventListener('pause', sync);

    controls.appendChild(playToggle);
    controls.appendChild(progress);
    controls.appendChild(muteToggle);
    media.appendChild(controls);
    sync();
  }

  function initFounderVideoInline() {
    document.querySelectorAll('.artmere-founder[data-founder-video-state]').forEach(function(section) {
      var media = section.querySelector('.artmere-founder__media');
      var video = media ? media.querySelector('.artmere-founder__video') : null;
      var triggers = section.querySelectorAll('[data-artmere-founder-inline-trigger]');
      if (!media || !video || !triggers.length) return;

      var controlsBuilt = false;
      var replayLabel = isGermanPage() ? 'Gründervideo erneut abspielen' : 'Replay founder video';
      var videoTrigger = section.querySelector('.artmere-founder__video-trigger[data-artmere-founder-inline-trigger]');

      function startPlayback() {
        var deferredSource = video.querySelector('source[data-artmere-founder-src]');
        if (deferredSource) {
          deferredSource.src = deferredSource.getAttribute('data-artmere-founder-src');
          deferredSource.removeAttribute('data-artmere-founder-src');
          video.load();
        }
        video.removeAttribute('aria-hidden');
        video.removeAttribute('tabindex');
        video.muted = false;
        video.currentTime = 0;
        section.setAttribute('data-founder-video-state', 'playing');
        if (!controlsBuilt) {
          buildFounderInlineControls(media, video);
          controlsBuilt = true;
        }
        var playPromise = video.play();
        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(function() {
            // Rare WebKit edge case: retry muted so playback still starts
            // even if unmuted autoplay is refused despite the user gesture.
            video.muted = true;
            video.play().catch(function() {});
          });
        }
      }

      triggers.forEach(function(trigger) {
        trigger.addEventListener('click', function(event) {
          event.preventDefault();
          startPlayback();
        });
      });

      video.addEventListener('click', function() {
        if (section.getAttribute('data-founder-video-state') !== 'playing') return;
        if (video.paused) {
          var pending = video.play();
          if (pending && typeof pending.catch === 'function') pending.catch(function() {});
        } else {
          video.pause();
        }
      });

      video.addEventListener('ended', function() {
        section.setAttribute('data-founder-video-state', 'ended');
        if (videoTrigger) videoTrigger.setAttribute('aria-label', replayLabel);
      });
    });
  }

  /* ============================================================
   * ABOUT FOUNDER VIDEO FALLBACK
   * Shopify can serve cached AI block HTML after a block edit. This
   * upgrades the old portrait markup until the fresh Liquid render arrives.
   * ============================================================ */
  function initAboutFounderVideoFallback() {
    if (window.location.pathname.indexOf('/pages/about-page') === -1) return;

    document.querySelectorAll('[id*="artmere_founder_director_about_video"]').forEach(function(section) {
      section.remove();
    });

    if (document.querySelector('[class*="ai-brand-story-founder-video-media-"], [data-artmere-founder-video-fallback]')) return;

    var wrapper = document.querySelector('[class*="ai-brand-story-founder-image-wrapper-"]');
    if (!wrapper || wrapper.querySelector('[data-artmere-founder-video-fallback]')) return;

    var image = wrapper.querySelector('img[class*="ai-brand-story-founder-image-"]');
    if (!image) return;

    var videoUrl = 'https://cdn.shopify.com/videos/c/vp/ccb5fe69e6954fc1bda27ea49b9b550a/ccb5fe69e6954fc1bda27ea49b9b550a.HD-1080p-3.3Mbps-88910543.mp4';

    if (!document.querySelector('style[data-artmere-founder-video-fallback-style]')) {
      var style = document.createElement('style');
      style.setAttribute('data-artmere-founder-video-fallback-style', 'true');
      style.textContent = [
        '.artmere-founder-inline-video{position:relative;width:200px;height:200px;border-radius:50%;overflow:hidden;background:#f4f4f4;isolation:isolate;}',
        '.artmere-founder-inline-video>img{display:block;width:100%!important;height:100%!important;border-radius:50%;object-fit:cover;object-position:50% 60%;transition:opacity .2s ease;}',
        '.artmere-founder-inline-video video{position:absolute;inset:0;width:100%;height:100%;border-radius:50%;object-fit:cover;object-position:50% 60%;opacity:0;pointer-events:none;transition:opacity .2s ease;background:#111;}',
        '.artmere-founder-inline-video.is-playing>img{opacity:0;}',
        '.artmere-founder-inline-video.is-playing video{opacity:1;pointer-events:auto;}',
        '.artmere-founder-inline-play{position:absolute;inset:0;display:flex;align-items:center;justify-content:center;width:100%;height:100%;padding:0;border:0;border-radius:50%;background:rgba(20,24,20,.18);cursor:pointer;z-index:2;}',
        '.artmere-founder-inline-play:hover{background:rgba(20,24,20,.26);}',
        '.artmere-founder-inline-play span{position:relative;display:block;width:58px;height:58px;border-radius:50%;background:rgba(255,255,255,.94);box-shadow:0 12px 34px rgba(0,0,0,.2);}',
        '.artmere-founder-inline-play span:after{content:"";position:absolute;top:50%;left:52%;transform:translate(-38%,-50%);width:0;height:0;border-top:11px solid transparent;border-bottom:11px solid transparent;border-left:16px solid #2d3a2e;}',
        '.artmere-founder-inline-video.is-playing .artmere-founder-inline-play{display:none;}',
        '@media(max-width:749px){.artmere-founder-inline-video{width:190px;height:190px}.artmere-founder-inline-play span{width:54px;height:54px}}'
      ].join('\n');
      document.head.appendChild(style);
    }

    var media = document.createElement('div');
    media.className = 'artmere-founder-inline-video';
    media.setAttribute('data-artmere-founder-video-fallback', 'true');
    wrapper.insertBefore(media, image);
    media.appendChild(image);

    var video = document.createElement('video');
    video.setAttribute('playsinline', '');
    video.setAttribute('preload', 'none');
    video.setAttribute('controls', '');
    video.setAttribute('aria-label', 'Moritz Danner speaking about ARTMERE');
    video.setAttribute('poster', image.currentSrc || image.src);

    var source = document.createElement('source');
    source.setAttribute('src', videoUrl);
    source.setAttribute('type', 'video/mp4');
    video.appendChild(source);
    media.appendChild(video);

    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'artmere-founder-inline-play';
    button.setAttribute('data-artmere-founder-modal-trigger', '');
    button.setAttribute('data-video-src', videoUrl);
    button.setAttribute('data-video-poster', image.currentSrc || image.src);
    button.setAttribute('data-video-label', 'Moritz Danner speaking about ARTMERE');
    button.setAttribute('aria-label', 'Play founder video');
    button.innerHTML = '<span aria-hidden="true"></span>';
    media.appendChild(button);
  }


  /* ============================================================
   * HOMEPAGE IMAGE CACHE FALLBACK
   * Old Shopify full-page cache variants can keep oversized image URLs
   * after the Liquid render has been fixed. Correct only the known images.
   * ============================================================ */
  function initHomepageImageCacheFallback() {
    function withWidth(raw, width) {
      try {
        var url = new URL(raw, window.location.href);
        url.searchParams.set('width', String(width));
        return url.href;
      } catch(e) {
        return raw;
      }
    }

    function textureSrcset(raw) {
      return [320, 533].map(function(width) {
        return withWidth(raw, width) + ' ' + width + 'w';
      }).join(', ');
    }

    document.querySelectorAll('.artmere-texture-proof__image').forEach(function(img) {
      var source = img.getAttribute('src') || img.currentSrc || '';
      if (source.indexOf('Closeup_B_Seitlicher_Streifblick_30') === -1 &&
          source.indexOf('Cherry_Sky_Closeup_B') === -1) {
        return;
      }

      var normalized = withWidth(source, 533);
      img.setAttribute('src', normalized);
      img.setAttribute('srcset', textureSrcset(normalized));
      img.setAttribute('sizes', '(max-width: 420px) 76vw, (max-width: 989px) 304px, (max-width: 1299px) 38vw, 520px');
      img.setAttribute('width', '533');
      img.setAttribute('height', '533');
    });

    var founderVideo = document.querySelector('.artmere-founder__video[poster*="width=1200"]');
    if (founderVideo) {
      founderVideo.setAttribute('poster', withWidth(founderVideo.getAttribute('poster'), 533));
    }
  }


  /* ============================================================
   * Policy body locale override
   * Shopify legal policy writes are not available to this app token,
   * so we replace the visible policy body from checked local sources.
   * ============================================================ */
  function initPolicyBodyOverride() {
    var path = window.location.pathname || '';
    var policyKey = null;
    if (path.indexOf('/policies/refund-policy') !== -1) policyKey = 'refund';
    if (path.indexOf('/policies/privacy-policy') !== -1) policyKey = 'privacy';
    if (path.indexOf('/policies/shipping-policy') !== -1) policyKey = 'shipping';
    if (!policyKey) return;

    var content = {
      refund: {
        en: { title: "Return & Refund Policy", body: `<p><strong>Effective: July 22, 2026</strong></p>
<p>This policy applies to orders placed through www.theartmere.com.</p>

<section id="online-withdrawal" style="border:1px solid #d8d3ca; padding:18px 20px; margin:24px 0 32px; background:#fbfaf7; box-sizing:border-box; width:min(100%, calc(100vw - 72px)); max-width:100%; overflow-wrap:break-word;">
<h2 style="margin-top:0;">Withdraw from a contract online</h2>
<p>If you want to withdraw from a contract, you can submit your declaration online here. We then review whether and to what extent a statutory right of withdrawal applies. The statutory right may be excluded for goods made to an individual customer specification or clearly personalised.</p>
<form id="artmere-withdrawal-form" method="post" action="/contact#online-withdrawal" accept-charset="UTF-8" style="margin-top:18px;">
<input type="hidden" name="form_type" value="contact">
<input type="hidden" name="utf8" value="&#10003;">
<input type="hidden" name="contact[tags]" value="eu-withdrawal,right-of-withdrawal,refund-policy">
<input type="hidden" name="contact[Withdrawal declaration]" value="I hereby withdraw from the contract.">
<p style="margin:0 0 14px;">Please provide the information we need to identify your order. You do not need to give a reason for withdrawal.</p>
<p><label for="withdrawal-name">Name</label><br><input id="withdrawal-name" name="contact[name]" type="text" autocomplete="name" required style="width:100%; max-width:520px;"></p>
<p><label for="withdrawal-email">Email</label><br><input id="withdrawal-email" name="contact[email]" type="email" autocomplete="email" required style="width:100%; max-width:520px;"></p>
<p><label for="withdrawal-order">Order number or other information identifying the contract</label><br><input id="withdrawal-order" name="contact[Order number or contract identifier]" type="text" required style="width:100%; max-width:520px;"></p>
<p><label for="withdrawal-message">Additional information, optional</label><br><textarea id="withdrawal-message" name="contact[body]" rows="4" style="width:100%; max-width:520px;"></textarea></p>
<p style="font-size:0.95em; margin:12px 0;">Information about how we process your details is available in our <a href="/policies/privacy-policy">Privacy Policy</a>.</p>
<button type="submit" style="padding:12px 18px; border:0; background:#111; color:#fff; cursor:pointer; font-weight:600;">Confirm withdrawal</button>
<p style="font-size:0.95em; margin-top:12px;">By clicking "Confirm withdrawal", you submit your withdrawal declaration electronically.</p>
</form>
</section>

<hr>

<h2>1. Our Commitment</h2>
<p>ARTMERE creates hand-painted original artworks on canvas. Each piece is made to order by skilled artists and reviewed before shipping. This policy explains our voluntary 60-day satisfaction guarantee, our preview process and your rights if an artwork arrives damaged, incorrect or not as approved.</p>

<hr>

<h2>2. ARTMERE 60-Day Satisfaction Guarantee</h2>
<p>In addition to any statutory rights you may have, we offer a voluntary <strong>60-day satisfaction guarantee</strong> from the date of delivery. If you are not satisfied with your artwork, contact us within 60 days of delivery at hello@theartmere.com.</p>
<p>Depending on the situation, we may offer:</p>
<ul>
<li>adjustments by the original artist;</li>
<li>a repaint by another artist, once per order;</li>
<li>or a return and refund of the purchase price.</li>
</ul>
<p>For a voluntary return, the artwork must be in the same condition as received and in its original packaging. Return shipping costs are the collector's responsibility unless the return is due to a defect, shipping damage or an error on our part.</p>
<p><strong>The 60-day satisfaction guarantee does not apply to:</strong></p>
<ul>
<li>custom commissions or special custom-size works that are not listed in our standard catalog once production has started;</li>
<li>artworks from a Limited Edition Collection;</li>
<li>gift cards.</li>
</ul>
<p>This voluntary guarantee does not limit any mandatory consumer rights that may apply in your country or state.</p>

<hr>

<h2>3. Preview Before Shipping</h2>
<p>Before your artwork is shipped, we send preview images of your finished painting for review. If something important feels off, we work with the artist on adjustments before the piece is approved for dispatch. Once you approve the preview, the artwork enters final quality control, packaging and shipping.</p>

<hr>

<h2>4. Cancellations</h2>
<p>You may cancel or modify your order within 48 hours of purchase at no cost. After 48 hours, a 15 percent cancellation fee may apply outside any statutory right of withdrawal to cover administrative and artist preparation costs. Once production has started and you have received preview images, voluntary cancellation is no longer available for standard catalog orders. Custom commissions made to your personal specification are non-refundable under our voluntary cancellation policy once production has started. Statutory withdrawal and warranty rights remain unaffected.</p>

<hr>

<h2>5. Damaged, Defective or Incorrect Orders</h2>
<p>If your order arrives damaged, defective or incorrect, contact us within 7 business days at hello@theartmere.com with clear photographs of the issue and a short description. After verification, we will arrange a repair, replacement or refund depending on the situation. This right applies regardless of your location and is in addition to any statutory rights you may have.</p>

<hr>

<h2>6. Missing Orders</h2>
<p>If your order has not arrived within 30 business days of the confirmed shipping date, contact us at hello@theartmere.com. We will investigate with the carrier and arrange a replacement shipment or refund if the shipment is confirmed lost.</p>

<hr>

<h2>7. Refund Processing</h2>
<p>Approved refunds are processed to the original payment method within 10 business days. Your bank or card provider may need additional time to complete the transaction. If more than 15 business days have passed since refund approval, contact us at hello@theartmere.com.</p>

<hr>

<h2>8. Exchanges</h2>
<p>We do not offer direct exchanges. If you would like another artwork, please return or cancel the original order according to this policy and place a new order.</p>

<hr>

<h2>9. Statutory Right of Withdrawal for Consumers in the European Union</h2>

<h3>9.1 Exclusion for genuinely personalised goods</h3>
<p>Under Article 16(c) of Directive 2011/83/EU and Section 312g paragraph 2 number 1 of the German Civil Code (BGB), the statutory right of withdrawal does not apply to contracts for goods that are not prefabricated and are made on the basis of an individual choice or decision by the consumer, or that are clearly personalised.</p>
<p>At ARTMERE, this exclusion applies only where those legal requirements are met in the individual case, particularly for genuine commissions or special orders made to a customer's personal specification. The fact that an artwork is painted only after an order is placed, or that a customer selects a design, standard size and frame from our catalogue, does not automatically exclude the statutory right of withdrawal.</p>

<h3>9.2 Instructions on withdrawal</h3>
<p>The following instructions apply where the statutory right of withdrawal is not excluded.</p>
<p><strong>Right of withdrawal</strong></p>
<p>You have the right to withdraw from this contract within fourteen days without giving any reason. The withdrawal period is fourteen days from the day on which you, or a third party named by you who is not the carrier, acquired physical possession of the goods.</p>
<p>To exercise the right of withdrawal, you must inform us:</p>
<p><strong>The Artmere UG (haftungsbeschr&auml;nkt)</strong><br>
Cotheniusstrasse 19, 10407 Berlin, Germany<br>
Email: hello@theartmere.com<br>
Telephone: +49 163 1389600</p>
<p>of your decision to withdraw from this contract by an unequivocal statement, for example by email or post. To meet the withdrawal deadline, it is sufficient for you to send your communication concerning your exercise of the right of withdrawal before the withdrawal period has expired.</p>
<p>You may also submit your withdrawal through our online form at <a href="https://www.theartmere.com/policies/refund-policy#online-withdrawal">www.theartmere.com/policies/refund-policy#online-withdrawal</a>.</p>
<p><strong>Effects of withdrawal</strong></p>
<p>If you withdraw from this contract, we will reimburse all payments received from you, including delivery costs, except for additional costs resulting from your choice of a delivery method other than the least expensive standard delivery offered by us. We will reimburse you without undue delay and no later than fourteen days after the day on which we are informed of your decision to withdraw. We will use the same means of payment that you used for the original transaction unless you expressly agree otherwise. You will not incur any fees as a result of the reimbursement. We may withhold reimbursement until we have received the goods back or you have supplied evidence of having sent the goods back, whichever occurs first.</p>
<p>You must send back or hand over the goods without undue delay and no later than fourteen days from the day on which you communicate your withdrawal to us. The deadline is met if you send the goods before the fourteen-day period has expired. You bear the direct cost of returning the goods.</p>

<hr>

<h2>10. Model Withdrawal Form</h2>
<p>Complete and return this form only if you wish to withdraw from the contract.</p>
<p>To:<br>
The Artmere UG (haftungsbeschr&auml;nkt)<br>
Cotheniusstrasse 19, 10407 Berlin, Germany<br>
Email: hello@theartmere.com<br>
Telephone: +49 163 1389600</p>
<p>I/We (*) hereby give notice that I/We (*) withdraw from my/our (*) contract of sale of the following goods (*)/for the supply of the following service (*):</p>
<ul>
<li>Ordered on (*)/received on (*):</li>
<li>Name of consumer(s):</li>
<li>Address of consumer(s):</li>
<li>Signature of consumer(s), only if this form is submitted on paper:</li>
<li>Date:</li>
</ul>
<p>(*) Delete as appropriate.</p>
<p>Our 60-day satisfaction guarantee and our damage policy still apply as described above. Mandatory consumer rights remain unaffected.</p>

<hr>

<h2>11. Contact</h2>
<p>If you have questions about returns, refunds or this policy, contact us:</p>
<p>The Artmere UG (haftungsbeschraenkt)<br>
Cotheniusstrasse 19, 10407 Berlin, Germany<br>
Email: hello@theartmere.com<br>
Website: www.theartmere.com</p>
<p>We usually respond within 24 hours on business days.</p>

<hr>

<p><em>This policy was last updated on July 22, 2026. We may update this policy from time to time. Changes apply to orders placed after the updated policy is published. This document is not legal advice.</em></p>` },
        de: { title: "Widerrufs- und Rückgaberichtlinie", body: `<p><strong>Stand: 22. Juli 2026</strong></p>
<p>Diese Richtlinie gilt f&uuml;r alle Bestellungen &uuml;ber www.theartmere.com.</p>

<section id="online-widerruf" style="border:1px solid #d8d3ca; padding:18px 20px; margin:24px 0 32px; background:#fbfaf7; box-sizing:border-box; width:min(100%, calc(100vw - 72px)); max-width:100%; overflow-wrap:break-word;">
<h2 style="margin-top:0;">Vertrag online widerrufen</h2>
<p>Wenn du einen Vertrag widerrufen m&ouml;chtest, kannst du deine Erkl&auml;rung hier online &uuml;bermitteln. Wir pr&uuml;fen anschlie&szlig;end, ob und in welchem Umfang ein gesetzliches Widerrufsrecht besteht. Bei Waren, die nach einer individuellen Kundenspezifikation angefertigt oder eindeutig auf pers&ouml;nliche Bed&uuml;rfnisse zugeschnitten werden, kann das gesetzliche Widerrufsrecht ausgeschlossen sein.</p>
<form id="artmere-withdrawal-form" method="post" action="/de/contact#online-widerruf" accept-charset="UTF-8" style="margin-top:18px;">
<input type="hidden" name="form_type" value="contact">
<input type="hidden" name="utf8" value="&#10003;">
<input type="hidden" name="contact[tags]" value="eu-withdrawal,right-of-withdrawal,refund-policy">
<input type="hidden" name="contact[Widerrufserklaerung]" value="Hiermit widerrufe ich den Vertrag.">
<p style="margin:0 0 14px;">Bitte gib die Angaben an, mit denen wir deine Bestellung zuordnen k&ouml;nnen. Ein Grund f&uuml;r den Widerruf ist nicht erforderlich.</p>
<p><label for="withdrawal-name">Name</label><br><input id="withdrawal-name" name="contact[name]" type="text" autocomplete="name" required style="width:100%; max-width:520px;"></p>
<p><label for="withdrawal-email">E-Mail</label><br><input id="withdrawal-email" name="contact[email]" type="email" autocomplete="email" required style="width:100%; max-width:520px;"></p>
<p><label for="withdrawal-order">Bestellnummer oder andere Angabe zur Identifizierung des Vertrags</label><br><input id="withdrawal-order" name="contact[Bestellnummer oder Vertragsangabe]" type="text" required style="width:100%; max-width:520px;"></p>
<p><label for="withdrawal-message">Weitere Angaben, optional</label><br><textarea id="withdrawal-message" name="contact[body]" rows="4" style="width:100%; max-width:520px;"></textarea></p>
<p style="font-size:0.95em; margin:12px 0;">Informationen zur Verarbeitung deiner Angaben findest du in unserer <a href="/de/policies/privacy-policy">Datenschutzerkl&auml;rung</a>.</p>
<button type="submit" style="padding:12px 18px; border:0; background:#111; color:#fff; cursor:pointer; font-weight:600;">Widerruf best&auml;tigen</button>
<p style="font-size:0.95em; margin-top:12px;">Mit Klick auf &quot;Widerruf best&auml;tigen&quot; &uuml;bermittelst du deine Widerrufserkl&auml;rung elektronisch.</p>
</form>
</section>

<hr>

<h2>1. Unser Versprechen</h2>
<p>Bei ARTMERE liegt uns au&szlig;ergew&ouml;hnliche Qualit&auml;t und Kundenzufriedenheit am Herzen. Jedes Kunstwerk wird auf Bestellung von erfahrenen K&uuml;nstlern handgemalt und durchl&auml;uft eine gr&uuml;ndliche Qualit&auml;tskontrolle vor dem Versand. Diese Richtlinie erl&auml;utert deine Rechte und unsere Pflichten nach geltendem Recht, einschlie&szlig;lich des EU- und deutschen Fernabsatzrechts.</p>

<hr>

<h2>2. ARTMERE 60-Tage-Zufriedenheitsgarantie</h2>
<p>Zus&auml;tzlich zu deinen gesetzlichen Rechten bieten wir eine <strong>freiwillige 60-Tage-Zufriedenheitsgarantie</strong> ab dem Lieferdatum. Wenn du mit deinem Kunstwerk nicht zufrieden bist, kontaktiere uns innerhalb von 60 Tagen nach Erhalt unter hello@theartmere.com. Wir bieten dir je nach Situation folgende Optionen:</p>
<ul>
<li>Kostenlose Anpassungen durch den Originalk&uuml;nstler</li>
<li>Eine vollst&auml;ndige Neuanfertigung durch einen anderen K&uuml;nstler (einmalig pro Bestellung)</li>
<li>R&uuml;ckgabe und Erstattung des Kaufpreises</li>
</ul>
<p>F&uuml;r eine freiwillige R&uuml;ckgabe muss das Kunstwerk im gleichen Zustand wie bei Erhalt und in der Originalverpackung sein. Die R&uuml;cksendekosten tr&auml;gst du, es sei denn, die R&uuml;ckgabe erfolgt aufgrund eines Mangels, Transportschadens oder Fehlers unsererseits.</p>
<p><strong>Ausgenommen von der 60-Tage-Zufriedenheitsgarantie sind:</strong></p>
<ul>
<li>Individuelle Sonderanfertigungen (Ma&szlig;anfertigung), die nicht in unserem Standardkatalog gelistet sind, sobald die Produktion begonnen hat</li>
<li>Kunstwerke aus der Limited Edition Collection</li>
<li>Geschenkkarten</li>
</ul>
<p>Diese Zufriedenheitsgarantie ist eine freiwillige Leistung von ARTMERE und besteht zus&auml;tzlich zu deinen gesetzlichen Rechten. Deine gesetzlichen Rechte bleiben hiervon unber&uuml;hrt.</p>

<hr>

<h2>3. Vorschau vor dem Versand</h2>
<p>Bevor dein Kunstwerk versendet wird, erh&auml;ltst du Vorschaubilder deines fertiggestellten Gem&auml;ldes. Wenn etwas Wichtiges nicht stimmig wirkt, stimmen wir Anpassungen mit dem K&uuml;nstler ab, bevor das Werk f&uuml;r den Versand freigegeben wird. Sobald du die Vorschau freigibst, geht das Gem&auml;lde in Endkontrolle, Verpackung und Versand.</p>

<hr>

<h2>4. Stornierung</h2>
<p>Du kannst deine Bestellung innerhalb von 48 Stunden nach dem Kauf kostenlos stornieren oder &auml;ndern. Nach 48 Stunden kann au&szlig;erhalb eines bestehenden gesetzlichen Widerrufsrechts eine Stornierungsgeb&uuml;hr von 15 Prozent anfallen, um Verwaltungs- und K&uuml;nstlervorbereitungskosten zu decken. Sobald die Produktion begonnen hat und du ein Vorschaubild erhalten hast, ist eine freiwillige Stornierung f&uuml;r Standardkatalog-Bestellungen nicht mehr m&ouml;glich.</p>
<p>Individuelle Sonderanfertigungen, also Gem&auml;lde, die nicht in unserem Standardkatalog gelistet und nach deiner pers&ouml;nlichen Spezifikation angefertigt werden, sind nach Produktionsbeginn im Rahmen unserer freiwilligen Stornierungsregelung nicht erstattungsf&auml;hig. Gesetzliche Widerrufs- und Gew&auml;hrleistungsrechte bleiben unber&uuml;hrt.</p>

<hr>

<h2>5. Besch&auml;digte, mangelhafte oder falsche Lieferungen</h2>
<p>Wenn deine Bestellung besch&auml;digt, mangelhaft oder falsch ankommt, kontaktiere uns bitte innerhalb von 7 Werktagen unter hello@theartmere.com mit deutlichen Fotos des Problems und einer kurzen Beschreibung. Nach &Uuml;berpr&uuml;fung veranlassen wir je nach Situation eine Reparatur, einen Ersatz oder eine Erstattung. Dieses Recht gilt unabh&auml;ngig von deinem Standort und besteht zus&auml;tzlich zu deinen gesetzlichen Rechten.</p>

<hr>

<h2>6. Fehlende Bestellungen</h2>
<p>Wenn deine Bestellung nicht innerhalb von 30 Werktagen nach dem best&auml;tigten Versanddatum angekommen ist, kontaktiere uns bitte unter hello@theartmere.com. Wir untersuchen den Fall mit dem Versanddienstleister und veranlassen eine Nachlieferung oder Erstattung, wenn die Sendung als verloren best&auml;tigt wird.</p>

<hr>

<h2>7. Limited Edition Collection</h2>
<p>Kunstwerke aus unserer Limited Edition Collection werden in streng limitierter St&uuml;ckzahl produziert und ausschlie&szlig;lich auf Bestellung angefertigt. Aufgrund ihres exklusiven Charakters sind Limited-Edition-Kunstwerke nicht r&uuml;ckgabe- oder erstattungsf&auml;hig, au&szlig;er bei Transportsch&auml;den. Deine gesetzlichen Rechte bleiben hiervon unber&uuml;hrt.</p>

<hr>

<h2>8. Erstattungsabwicklung</h2>
<p>Genehmigte Erstattungen werden innerhalb von 10 Werktagen auf deine urspr&uuml;ngliche Zahlungsmethode veranlasst. Bitte rechne mit zus&auml;tzlicher Bearbeitungszeit durch deine Bank oder deinen Kreditkartenanbieter. Wenn seit der Erstattungsgenehmigung mehr als 15 Werktage vergangen sind, kontaktiere uns bitte unter hello@theartmere.com.</p>

<hr>

<h2>9. Umtausch</h2>
<p>Wir bieten keinen direkten Umtausch an. Wenn du ein anderes Kunstwerk m&ouml;chtest, gib die Originalbestellung bitte gem&auml;&szlig; den oben genannten Bedingungen zur&uuml;ck oder storniere sie und gib eine neue Bestellung auf.</p>

<hr>

<h2>10. Gesetzliches Widerrufsrecht (EU und Deutschland)</h2>

<h3>10.1 Hinweis zum Widerrufsausschluss bei individuell angefertigten Waren</h3>
<p>Gem&auml;&szlig; Art. 16 lit. c der Richtlinie 2011/83/EU und &sect; 312g Abs. 2 Nr. 1 BGB besteht das gesetzliche Widerrufsrecht nicht bei Vertr&auml;gen zur Lieferung von Waren, die nicht vorgefertigt sind und f&uuml;r deren Herstellung eine individuelle Auswahl oder Bestimmung durch den Verbraucher ma&szlig;geblich ist oder die eindeutig auf die pers&ouml;nlichen Bed&uuml;rfnisse des Verbrauchers zugeschnitten sind.</p>
<p>Dieser Ausschluss gilt bei ARTMERE nur, wenn diese gesetzlichen Voraussetzungen im konkreten Einzelfall erf&uuml;llt sind, insbesondere bei echten Auftragsarbeiten oder Sonderanfertigungen nach einer pers&ouml;nlichen Kundenspezifikation. Der blo&szlig;e Umstand, dass ein Werk erst nach der Bestellung handgemalt wird oder du eine im Standardkatalog angebotene Kombination aus Motiv, Standardgr&ouml;&szlig;e und Rahmen ausw&auml;hlst, f&uuml;hrt nicht automatisch zum Ausschluss des gesetzlichen Widerrufsrechts.</p>
<p>Unsere 60-Tage-Zufriedenheitsgarantie und unsere Regelungen bei Transportsch&auml;den gelten jedoch in vollem Umfang. Du erh&auml;ltst immer eine Vorschau vor dem Versand, und wir ersetzen oder erstatten besch&auml;digte Ware stets.</p>

<h3>10.2 Widerrufsbelehrung</h3>
<p>Aus Transparenzgr&uuml;nden und zur Erf&uuml;llung der deutschen Informationspflichten gem&auml;&szlig; &sect; 312d BGB i.V.m. Art. 246a EGBGB gilt die folgende Widerrufsbelehrung, soweit das Widerrufsrecht nicht gem&auml;&szlig; &sect; 312g Abs. 2 Nr. 1 BGB ausgeschlossen ist:</p>

<p><strong>Widerrufsrecht</strong></p>
<p>Du hast das Recht, binnen vierzehn Tagen ohne Angabe von Gr&uuml;nden diesen Vertrag zu widerrufen. Die Widerrufsfrist betr&auml;gt vierzehn Tage ab dem Tag, an dem du oder ein von dir benannter Dritter, der nicht der Bef&ouml;rderer ist, die Waren in Besitz genommen hast bzw. hat.</p>

<p>Um dein Widerrufsrecht auszu&uuml;ben, musst du uns:</p>
<p><strong>The Artmere UG (haftungsbeschr&auml;nkt)</strong><br>
Cotheniusstra&szlig;e 19, 10407 Berlin, Deutschland<br>
E-Mail: hello@theartmere.com<br>
Telefon: +49 163 1389600</p>
<p>mittels einer eindeutigen Erkl&auml;rung (z.&nbsp;B. per E-Mail oder Post) &uuml;ber deinen Entschluss, diesen Vertrag zu widerrufen, informieren. Zur Wahrung der Widerrufsfrist reicht es aus, dass du die Mitteilung &uuml;ber die Aus&uuml;bung des Widerrufsrechts vor Ablauf der Widerrufsfrist absendest.</p>
<p>Du kannst deinen Widerruf au&szlig;erdem &uuml;ber unser Online-Formular unter <a href="https://www.theartmere.com/de/policies/refund-policy#online-widerruf">www.theartmere.com/de/policies/refund-policy#online-widerruf</a> &uuml;bermitteln.</p>

<p><strong>Folgen des Widerrufs</strong></p>
<p>Wenn du diesen Vertrag widerrufst, haben wir dir alle Zahlungen, die wir von dir erhalten haben, einschlie&szlig;lich der Lieferkosten (mit Ausnahme der zus&auml;tzlichen Kosten, die sich daraus ergeben, dass du eine andere Art der Lieferung als die von uns angebotene, g&uuml;nstigste Standardlieferung gew&auml;hlt hast), unverz&uuml;glich und sp&auml;testens binnen vierzehn Tagen ab dem Tag zur&uuml;ckzuzahlen, an dem die Mitteilung &uuml;ber deinen Widerruf dieses Vertrags bei uns eingegangen ist. F&uuml;r diese R&uuml;ckzahlung verwenden wir dasselbe Zahlungsmittel, das du bei der urspr&uuml;nglichen Transaktion eingesetzt hast, es sei denn, mit dir wurde ausdr&uuml;cklich etwas anderes vereinbart. Wir k&ouml;nnen die R&uuml;ckzahlung verweigern, bis wir die Waren zur&uuml;ckerhalten haben oder bis du den Nachweis erbracht hast, dass du die Waren zur&uuml;ckgesandt hast, je nachdem, welches der fr&uuml;here Zeitpunkt ist.</p>
<p>Du hast die Waren unverz&uuml;glich und in jedem Fall sp&auml;testens binnen vierzehn Tagen ab dem Tag, an dem du uns &uuml;ber den Widerruf dieses Vertrags unterrichtest, an uns zur&uuml;ckzusenden oder zu &uuml;bergeben. Die Frist ist gewahrt, wenn du die Waren vor Ablauf der Frist von vierzehn Tagen absendest. Du tr&auml;gst die unmittelbaren Kosten der R&uuml;cksendung der Waren.</p>

<p><strong>Hinweis:</strong> Das Widerrufsrecht besteht nicht bei Vertr&auml;gen zur Lieferung von Waren, die nicht vorgefertigt sind und f&uuml;r deren Herstellung eine individuelle Auswahl oder Bestimmung durch den Verbraucher ma&szlig;geblich ist oder die eindeutig auf die pers&ouml;nlichen Bed&uuml;rfnisse des Verbrauchers zugeschnitten sind. Ob dieser Ausschluss greift, richtet sich nach der konkreten Bestellung; er wird nicht allein dadurch ausgel&ouml;st, dass ein Werk erst nach der Bestellung handgemalt wird.</p>

<hr>

<h2>11. Muster-Widerrufsformular</h2>
<p>(F&uuml;lle dieses Formular nur aus und sende es zur&uuml;ck, wenn du den Vertrag widerrufen willst.)</p>
<p>An:<br>
The Artmere UG (haftungsbeschr&auml;nkt)<br>
Cotheniusstra&szlig;e 19, 10407 Berlin, Deutschland<br>
E-Mail: hello@theartmere.com<br>
Telefon: +49 163 1389600</p>
<p>Hiermit widerrufe(n) ich/wir (*) den von mir/uns (*) abgeschlossenen Vertrag &uuml;ber den Kauf der folgenden Waren (*)/die Erbringung der folgenden Dienstleistung (*):</p>
<ul>
<li>Bestellt am (*)/erhalten am (*):</li>
<li>Name des/der Verbraucher(s):</li>
<li>Anschrift des/der Verbraucher(s):</li>
<li>Unterschrift des/der Verbraucher(s) (nur bei Mitteilung auf Papier):</li>
<li>Datum:</li>
</ul>
<p>(*) Unzutreffendes streichen.</p>

<hr>

<h2>12. Verbraucherstreitbeilegung</h2>
<p>Gem&auml;&szlig; &sect; 36 des Verbraucherstreitbeilegungsgesetzes (VSBG) erkl&auml;ren wir, dass wir weder verpflichtet noch bereit sind, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen, sofern nicht gesetzlich vorgeschrieben.</p>

<hr>

<h2>13. Anwendbares Recht</h2>
<p>F&uuml;r Kunden in der Europ&auml;ischen Union gilt deutsches Recht, unbeschadet der zwingenden Verbraucherschutzbestimmungen deines Wohnsitzlandes.</p>
<p>Keine Bestimmung dieser Richtlinie ber&uuml;hrt deine gesetzlichen Rechte als Verbraucher nach den zwingenden Vorschriften des Rechts deines gew&ouml;hnlichen Aufenthaltslandes.</p>

<hr>

<h2>14. Kontakt</h2>
<p>Wenn du Fragen zu R&uuml;ckgaben, Erstattungen oder dieser Richtlinie hast, kontaktiere uns bitte:</p>
<p>The Artmere UG (haftungsbeschr&auml;nkt)<br>
Cotheniusstra&szlig;e 19, 10407 Berlin, Deutschland<br>
E-Mail: hello@theartmere.com<br>
Telefon: +49 163 1389600<br>
Website: www.theartmere.com</p>
<p>Unsere Antwortzeit betr&auml;gt in der Regel 24 Stunden an Werktagen.</p>

<hr>

<p><em>Diese Richtlinie wurde zuletzt am 22. Juli 2026 aktualisiert. Wir behalten uns das Recht vor, diese Richtlinie jederzeit zu aktualisieren. &Auml;nderungen werden auf unserer Website ver&ouml;ffentlicht und gelten f&uuml;r Bestellungen, die nach dem Datum der Aktualisierung aufgegeben werden. Dieses Dokument stellt keine Rechtsberatung dar.</em></p>` }
      },
      privacy: {
        en: { title: "Privacy Policy", body: `<p><strong>Effective: July 22, 2026</strong></p>
<p>We appreciate your interest in our online store. Protecting your privacy is important to us. This policy explains how we process your personal data.</p>

<hr>

<h2>1. Controller</h2>
<p>The controller responsible for processing personal data on this website within the meaning of the General Data Protection Regulation (GDPR) is:</p>
<p><strong>The Artmere UG (haftungsbeschr&auml;nkt)</strong><br>
trading as ARTMERE<br>
Cotheniusstrasse 19<br>
10407 Berlin<br>
Germany</p>
<p>Represented by: Moritz Danner, Managing Director<br>
Email: hello@theartmere.com<br>
Telephone: +49 163 1389600<br>
Website: www.theartmere.com</p>

<hr>

<h2>2. General information about data processing</h2>
<p>We process personal data only to the extent necessary to provide a functional website, our content and our services. We obtain consent where required. In other cases, processing is permitted because it is necessary for a contract, a legal obligation or a legitimate interest.</p>

<hr>

<h2>3. Legal bases</h2>
<ul>
<li><strong>Article 6(1)(a) GDPR, consent:</strong> for processing that requires your consent, such as analytics and marketing cookies or newsletters.</li>
<li><strong>Article 6(1)(b) GDPR, contract:</strong> where processing is necessary to enter into or perform a contract, such as order processing, payment and delivery.</li>
<li><strong>Article 6(1)(c) GDPR, legal obligation:</strong> where processing is required by law, such as tax retention duties or duties connected with statutory withdrawal rights.</li>
<li><strong>Article 6(1)(f) GDPR, legitimate interests:</strong> where processing is necessary for our or a third party's legitimate interests and your interests or fundamental rights do not override those interests, such as fraud prevention and website security.</li>
</ul>

<hr>

<h2>4. Hosting and technical operation</h2>
<p>This website is operated through the ecommerce platform <strong>Shopify</strong>. The service provider is Shopify International Limited, c/o Intertrust Ireland, 2nd Floor, 1-2 Victoria Buildings, Haddington Road, Dublin 4, D04 XN32, Ireland.</p>
<p>When you access our website, technical server data may be processed, including your IP address, access date and time, the page and URL requested, referrer URL, browser, operating system and the amount of data transferred.</p>
<p>The legal basis is Article 6(1)(f) GDPR, based on our legitimate interest in providing the website securely and efficiently. Shopify may process data in countries outside the European Economic Area. Where required, transfers are protected by appropriate safeguards such as the European Commission's Standard Contractual Clauses. More information is available in <a href="https://www.shopify.com/legal/privacy" target="_blank" rel="noopener">Shopify's Privacy Policy</a>.</p>

<hr>

<h2>5. Orders and contract performance</h2>
<p>When you place an order, we process data required to perform the contract, including:</p>
<ul>
<li>first and last name;</li>
<li>email address;</li>
<li>billing and delivery address;</li>
<li>telephone number for delivery coordination;</li>
<li>payment information, which is transmitted directly to the payment service provider;</li>
<li>order details such as products, sizes and prices.</li>
</ul>
<p>The legal basis is Article 6(1)(b) GDPR. We retain order data for applicable statutory retention periods, generally six or ten years under German commercial and tax law.</p>

<hr>

<h2>6. Payment service providers</h2>
<p>Payment data is transmitted to the payment provider selected at checkout. Depending on your selection, providers may include:</p>
<ul>
<li><strong>PayPal</strong>, PayPal (Europe) S.&agrave; r.l. et Cie, S.C.A., Luxembourg: <a href="https://www.paypal.com/de/webapps/mpp/ua/privacy-full" target="_blank" rel="noopener">Privacy Policy</a></li>
<li><strong>Klarna</strong>, Klarna Bank AB, Sweden: <a href="https://www.klarna.com/international/privacy-policy/" target="_blank" rel="noopener">Privacy Policy</a></li>
<li><strong>Shopify Payments / Stripe</strong>, Stripe Payments Europe, Ltd., Ireland: <a href="https://stripe.com/privacy" target="_blank" rel="noopener">Privacy Policy</a></li>
</ul>
<p>Other checkout options may include Apple Pay, Google Pay, Mastercard, Visa, American Express, Maestro, UnionPay and Shop Pay. The legal basis is Article 6(1)(b) GDPR.</p>

<hr>

<h2>7. Cookies and consent</h2>
<p>Our website uses cookies and similar technologies. Cookies required for the shopping cart, session management and other essential functions are processed on the basis of Article 6(1)(f) GDPR and Section 25(2)(2) of the German Telecommunications Digital Services Data Protection Act (TDDDG).</p>
<p>Analytics and marketing technologies are activated only with your consent. The legal basis is Article 6(1)(a) GDPR and Section 25(1) TDDDG. You can change or withdraw your consent at any time through the Cookie Settings link in the footer.</p>

<hr>

<h2>8. Analytics and advertising</h2>

<h3>8.1 Google Analytics 4</h3>
<p>With your consent, we use Google Analytics 4 from Google Ireland Limited, Gordon House, Barrow Street, Dublin 4, Ireland, to understand how our website is used. IP anonymisation is enabled. The legal basis is Article 6(1)(a) GDPR. Transfers to the United States are based on the EU-US Data Privacy Framework where applicable. More information: <a href="https://policies.google.com/privacy" target="_blank" rel="noopener">Google Privacy Policy</a>.</p>

<h3>8.2 Meta Pixel</h3>
<p>With your consent, we use the Meta Pixel from Meta Platforms Ireland Limited, 4 Grand Canal Square, Dublin 2, Ireland, to measure activity after a person visits our website from a Meta advertisement. The legal basis is Article 6(1)(a) GDPR. Transfers to the United States are based on the EU-US Data Privacy Framework where applicable. More information: <a href="https://www.facebook.com/privacy/policy/" target="_blank" rel="noopener">Meta Privacy Policy</a>.</p>

<hr>

<h2>9. Email marketing with Omnisend</h2>
<p>We use Omnisend UAB, Lithuania, for newsletters and transactional emails. Newsletter subscriptions use a double opt-in process. The legal basis for marketing emails is Article 6(1)(a) GDPR. You may unsubscribe at any time through the link in an email. More information: <a href="https://www.omnisend.com/privacy/" target="_blank" rel="noopener">Omnisend Privacy Policy</a>.</p>

<hr>

<h2>10. Spam protection with hCaptcha</h2>
<p>We use hCaptcha from Intuition Machines, Inc., United States, to protect forms against automated abuse. Data is transmitted to hCaptcha when a protected form is used so that the service can assess whether the input was made by a person. The legal basis is Article 6(1)(f) GDPR, based on our legitimate interest in protecting the website against spam and abuse. More information: <a href="https://www.hcaptcha.com/privacy" target="_blank" rel="noopener">hCaptcha Privacy Policy</a>.</p>

<hr>

<h2>11. Online withdrawal form</h2>
<p>If you use the online withdrawal form, we process the information you enter to identify the relevant contract, handle your declaration and communicate with you. This includes your name, email address, order number or another contract identifier, and any optional free-text information you provide.</p>
<p>The processing is necessary for pre-contractual or contractual measures and for compliance with our legal obligations relating to withdrawal rights under Article 6(1)(b) and (c) GDPR. We process technical security data on the basis of our legitimate interest in preventing abuse and fraud under Article 6(1)(f) GDPR.</p>
<p>The form is provided through the technical infrastructure of our Shopify store. More information about processing by Shopify is available in section 4 of this Privacy Policy.</p>

<hr>

<h2>12. SSL/TLS encryption</h2>
<p>This website uses SSL/TLS encryption to protect confidential content in transit. An encrypted connection is indicated by the https address and the lock symbol in your browser.</p>

<hr>

<h2>13. Your rights</h2>
<p>Subject to the applicable legal requirements, you may exercise the following rights:</p>
<ul>
<li>access under Article 15 GDPR;</li>
<li>rectification under Article 16 GDPR;</li>
<li>erasure under Article 17 GDPR;</li>
<li>restriction of processing under Article 18 GDPR;</li>
<li>data portability under Article 20 GDPR;</li>
<li>objection under Article 21 GDPR where processing is based on Article 6(1)(f) GDPR;</li>
<li>withdrawal of consent at any time with effect for the future under Article 7(3) GDPR.</li>
</ul>
<p>To exercise your rights, contact hello@theartmere.com.</p>

<hr>

<h2>14. Right to lodge a complaint</h2>
<p>You have the right to lodge a complaint with a data protection supervisory authority under Article 77 GDPR. The supervisory authority responsible for us is:</p>
<p>Berlin Commissioner for Data Protection and Freedom of Information<br>
Alt-Moabit 59-61<br>
10555 Berlin<br>
Germany<br>
<a href="https://www.datenschutz-berlin.de" target="_blank" rel="noopener">www.datenschutz-berlin.de</a></p>

<hr>

<h2>15. Retention periods</h2>
<p>We retain personal data only for as long as necessary for the stated purpose or as required by law. Typical retention periods include:</p>
<ul>
<li>order data: generally ten years where required by German tax law;</li>
<li>server logs: thirty days;</li>
<li>newsletter data: until consent is withdrawn;</li>
<li>Google Analytics data: fourteen months;</li>
<li>withdrawal correspondence: for as long as needed to handle the request, comply with statutory retention duties, or establish, exercise or defend legal claims.</li>
</ul>

<hr>

<h2>16. International data transfers</h2>
<p>Where personal data is transferred outside the European Union or European Economic Area, we use a valid transfer mechanism under Articles 44 et seq. GDPR, such as an adequacy decision, the EU-US Data Privacy Framework or the European Commission's Standard Contractual Clauses. This may apply to Google LLC, Meta Platforms, Inc., Shopify Inc. and Intuition Machines, Inc., depending on the service used.</p>

<hr>

<h2>17. Changes to this Privacy Policy</h2>
<p>We may update this Privacy Policy to reflect legal requirements or changes to our services. The version published on this website applies to your next visit.</p>

<hr>

<p><em>This Privacy Policy was last updated on July 22, 2026.</em></p>` },
        de: { title: "Datenschutzerklärung", body: `<p><strong>Stand: 22. Juli 2026</strong></p>
<p>Wir freuen uns &uuml;ber dein Interesse an unserem Online-Shop. Der Schutz deiner Privatsph&auml;re ist uns sehr wichtig. Nachstehend informieren wir dich ausf&uuml;hrlich &uuml;ber den Umgang mit deinen Daten.</p>

<hr>

<h2>1. Verantwortlicher</h2>
<p>Verantwortlich f&uuml;r die Datenverarbeitung auf dieser Website im Sinne der Datenschutz-Grundverordnung (DSGVO) ist:</p>
<p><strong>The Artmere UG (haftungsbeschr&auml;nkt)</strong><br>
handelnd unter dem Namen Artmere<br>
Cotheniusstra&szlig;e 19<br>
10407 Berlin<br>
Deutschland</p>
<p>Vertreten durch: Moritz Danner (Gesch&auml;ftsf&uuml;hrer)<br>
E-Mail: hello@theartmere.com<br>
Telefon: +49 163 1389600<br>
Website: www.theartmere.com</p>

<hr>

<h2>2. Allgemeines zur Datenverarbeitung</h2>
<p>Wir verarbeiten personenbezogene Daten unserer Nutzer grunds&auml;tzlich nur, soweit dies zur Bereitstellung einer funktionsf&auml;higen Website sowie unserer Inhalte und Leistungen erforderlich ist. Die Verarbeitung personenbezogener Daten erfolgt regelm&auml;&szlig;ig nur nach Einwilligung des Nutzers. Eine Ausnahme gilt in solchen F&auml;llen, in denen eine vorherige Einholung einer Einwilligung aus tats&auml;chlichen Gr&uuml;nden nicht m&ouml;glich ist und die Verarbeitung der Daten durch gesetzliche Vorschriften gestattet ist.</p>

<hr>

<h2>3. Rechtsgrundlagen der Verarbeitung</h2>
<p>Die Verarbeitung personenbezogener Daten erfolgt auf folgenden Rechtsgrundlagen:</p>
<ul>
<li><strong>Art. 6 Abs. 1 lit. a DSGVO</strong> (Einwilligung): Soweit wir f&uuml;r Verarbeitungsvorg&auml;nge personenbezogener Daten eine Einwilligung einholen (z.&nbsp;B. f&uuml;r Tracking-Cookies, Newsletter).</li>
<li><strong>Art. 6 Abs. 1 lit. b DSGVO</strong> (Vertragserf&uuml;llung): Soweit die Verarbeitung personenbezogener Daten zur Erf&uuml;llung eines Vertrages erforderlich ist (z.&nbsp;B. Bestellabwicklung, Lieferung, Zahlung).</li>
<li><strong>Art. 6 Abs. 1 lit. c DSGVO</strong> (Rechtliche Verpflichtung): Soweit eine Verarbeitung personenbezogener Daten zur Erf&uuml;llung einer rechtlichen Verpflichtung erforderlich ist (z.&nbsp;B. steuerliche Aufbewahrungspflichten).</li>
<li><strong>Art. 6 Abs. 1 lit. f DSGVO</strong> (Berechtigtes Interesse): Soweit die Verarbeitung zur Wahrung eines berechtigten Interesses unseres Unternehmens oder eines Dritten erforderlich ist und die Interessen, Grundrechte und Grundfreiheiten des Betroffenen das erstgenannte Interesse nicht &uuml;berwiegen (z.&nbsp;B. Betrugsvermeidung, Website-Sicherheit).</li>
</ul>

<hr>

<h2>4. Hosting und technische Bereitstellung</h2>
<p>Diese Website wird &uuml;ber die E-Commerce-Plattform <strong>Shopify Inc.</strong> (Shopify International Limited, c/o Intertrust Ireland, 2nd Floor, 1-2 Victoria Buildings, Haddington Road, Dublin 4, D04 XN32, Irland) betrieben. Shopify stellt die Server-Infrastruktur bereit, auf der unser Online-Shop l&auml;uft.</p>
<p>Bei jedem Aufruf unserer Website werden automatisch Informationen an den Server von Shopify &uuml;bermittelt (sog. Server-Logfiles). Dies umfasst:</p>
<ul>
<li>IP-Adresse des anfragenden Rechners</li>
<li>Datum und Uhrzeit des Zugriffs</li>
<li>Name und URL der abgerufenen Seite</li>
<li>Referrer-URL (zuvor besuchte Seite)</li>
<li>Verwendeter Browser und Betriebssystem</li>
<li>&Uuml;bertragene Datenmenge</li>
</ul>
<p>Rechtsgrundlage: Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an der sicheren und effizienten Bereitstellung der Website).</p>
<p>Shopify kann Daten auch in Rechenzentren in den USA und Kanada verarbeiten. Die &Uuml;bermittlung erfolgt auf Grundlage von Standardvertragsklauseln (Art. 46 Abs. 2 lit. c DSGVO). Weitere Informationen: <a href="https://www.shopify.com/legal/privacy" target="_blank" rel="noopener">Shopify Datenschutzerkl&auml;rung</a>.</p>

<hr>

<h2>5. Bestellvorgang und Vertragsabwicklung</h2>
<p>Wenn du eine Bestellung in unserem Shop aufgibst, erheben und verarbeiten wir die folgenden Daten zur Vertragsabwicklung:</p>
<ul>
<li>Vor- und Nachname</li>
<li>E-Mail-Adresse</li>
<li>Rechnungs- und Lieferanschrift</li>
<li>Telefonnummer (f&uuml;r Lieferkoordination)</li>
<li>Zahlungsinformationen (werden direkt an den Zahlungsdienstleister &uuml;bermittelt)</li>
<li>Bestelldetails (Produkte, Gr&ouml;&szlig;en, Preise)</li>
</ul>
<p>Rechtsgrundlage: Art. 6 Abs. 1 lit. b DSGVO (Vertragserf&uuml;llung).</p>
<p>Deine Bestelldaten speichern wir f&uuml;r die Dauer der gesetzlichen Aufbewahrungsfristen (in der Regel 6 bzw. 10 Jahre gem&auml;&szlig; HGB und AO).</p>

<hr>

<h2>6. Zahlungsdienstleister</h2>
<p>Wir bieten verschiedene Zahlungsmethoden an. Dabei werden deine Zahlungsdaten direkt an den jeweiligen Zahlungsdienstleister &uuml;bermittelt:</p>
<ul>
<li><strong>PayPal</strong> (PayPal (Europe) S.&agrave; r.l. et Cie, S.C.A., Luxemburg) &ndash; <a href="https://www.paypal.com/de/webapps/mpp/ua/privacy-full" target="_blank" rel="noopener">Datenschutzerkl&auml;rung</a></li>
<li><strong>Klarna</strong> (Klarna Bank AB, Schweden) &ndash; <a href="https://www.klarna.com/de/datenschutz/" target="_blank" rel="noopener">Datenschutzerkl&auml;rung</a></li>
<li><strong>Shopify Payments / Stripe</strong> (Stripe Payments Europe, Ltd., Irland) &ndash; <a href="https://stripe.com/de/privacy" target="_blank" rel="noopener">Datenschutzerkl&auml;rung</a></li>
</ul>
<p>Weitere Zahlungsmethoden: Apple Pay, Google Pay, Mastercard, Visa, American Express, Maestro, Union Pay, Shop Pay. Die Verarbeitung erfolgt jeweils &uuml;ber den zugeh&ouml;rigen Zahlungsdienstleister.</p>
<p>Rechtsgrundlage: Art. 6 Abs. 1 lit. b DSGVO (Vertragserf&uuml;llung).</p>

<hr>

<h2>7. Cookies und Einwilligung</h2>
<p>Unsere Website verwendet Cookies. Cookies sind kleine Textdateien, die auf deinem Endger&auml;t gespeichert werden.</p>
<p><strong>Technisch notwendige Cookies:</strong> Diese Cookies sind f&uuml;r den Betrieb der Website erforderlich (z.&nbsp;B. Warenkorb, Session). Rechtsgrundlage: Art. 6 Abs. 1 lit. f DSGVO, &sect; 25 Abs. 2 Nr. 2 TDDDG.</p>
<p><strong>Analyse- und Marketing-Cookies:</strong> Diese Cookies werden nur mit deiner ausdr&uuml;cklichen Einwilligung gesetzt. &Uuml;ber unser Cookie-Consent-Banner kannst du deine Einwilligung erteilen oder verweigern. Rechtsgrundlage: Art. 6 Abs. 1 lit. a DSGVO, &sect; 25 Abs. 1 TDDDG.</p>
<p>Du kannst deine Cookie-Einstellungen jederzeit &uuml;ber den Link &bdquo;Cookie-Einstellungen&ldquo; im Footer unserer Website &auml;ndern oder widerrufen.</p>

<hr>

<h2>8. Webanalyse</h2>

<h3>8.1 Google Analytics 4</h3>
<p>Wir nutzen Google Analytics 4, einen Webanalysedienst der Google Ireland Limited (&bdquo;Google&ldquo;), Gordon House, Barrow Street, Dublin 4, Irland. Google Analytics verwendet Cookies, die eine Analyse der Benutzung der Website erm&ouml;glichen.</p>
<p>Die durch das Cookie erzeugten Informationen &uuml;ber deine Benutzung dieser Website werden in der Regel an einen Server von Google in den USA &uuml;bertragen und dort gespeichert. Wir haben die IP-Anonymisierung aktiviert, sodass deine IP-Adresse von Google innerhalb der EU gek&uuml;rzt wird.</p>
<p>Google Analytics wird nur nach deiner ausdr&uuml;cklichen Einwilligung aktiviert.<br>
Rechtsgrundlage: Art. 6 Abs. 1 lit. a DSGVO (Einwilligung).<br>
Drittland&uuml;bermittlung: USA, auf Grundlage des EU-US Data Privacy Framework.<br>
<a href="https://policies.google.com/privacy" target="_blank" rel="noopener">Google Datenschutzerkl&auml;rung</a> | <a href="https://tools.google.com/dlpage/gaoptout" target="_blank" rel="noopener">Google Analytics Opt-Out</a></p>

<h3>8.2 Meta-Pixel (Facebook)</h3>
<p>Wir nutzen das Meta-Pixel der Meta Platforms Ireland Limited, 4 Grand Canal Square, Dublin 2, Irland. Das Meta-Pixel erm&ouml;glicht uns, das Verhalten von Nutzern nachzuverfolgen, nachdem diese durch Klicken auf eine Meta-Werbeanzeige auf unsere Website weitergeleitet wurden.</p>
<p>Das Meta-Pixel wird nur nach deiner ausdr&uuml;cklichen Einwilligung aktiviert.<br>
Rechtsgrundlage: Art. 6 Abs. 1 lit. a DSGVO (Einwilligung).<br>
Drittland&uuml;bermittlung: USA, auf Grundlage des EU-US Data Privacy Framework.<br>
<a href="https://www.facebook.com/privacy/policy/" target="_blank" rel="noopener">Meta Datenschutzerkl&auml;rung</a></p>

<hr>

<h2>9. E-Mail-Marketing (Omnisend)</h2>
<p>F&uuml;r den Versand von Newslettern und transaktionalen E-Mails nutzen wir den Dienst Omnisend (Omnisend UAB, Litauen). Wenn du dich f&uuml;r unseren Newsletter anmeldest, wird deine E-Mail-Adresse bei Omnisend gespeichert und f&uuml;r den E-Mail-Versand verarbeitet.</p>
<p>Die Newsletter-Anmeldung erfolgt im Double-Opt-in-Verfahren. Du erh&auml;ltst eine Best&auml;tigungs-E-Mail und dein Abonnement wird erst nach Klick auf den Best&auml;tigungslink aktiviert.</p>
<p>Du kannst den Newsletter jederzeit abbestellen, z.&nbsp;B. &uuml;ber den Abmeldelink in jeder E-Mail.<br>
Rechtsgrundlage: Art. 6 Abs. 1 lit. a DSGVO (Einwilligung).<br>
<a href="https://www.omnisend.com/privacy/" target="_blank" rel="noopener">Omnisend Datenschutzerkl&auml;rung</a></p>

<hr>

<h2>10. Spam-Schutz (hCaptcha)</h2>
<p>Wir verwenden hCaptcha (Intuition Machines, Inc., USA) zum Schutz unserer Formulare vor automatisiertem Missbrauch. Bei Nutzung eines Formulars werden Daten an hCaptcha &uuml;bermittelt, um zu pr&uuml;fen, ob die Eingabe durch einen Menschen erfolgt.</p>
<p>Rechtsgrundlage: Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse am Schutz vor Spam und Missbrauch).<br>
<a href="https://www.hcaptcha.com/privacy" target="_blank" rel="noopener">hCaptcha Datenschutzerkl&auml;rung</a></p>

<hr>

<h2>11. Online-Widerrufsformular</h2>
<p>Wenn du das Online-Widerrufsformular nutzt, verarbeiten wir die von dir eingegebenen Angaben, um den betroffenen Vertrag zu identifizieren, deine Erkl&auml;rung zu bearbeiten und die weitere Kommunikation mit dir zu f&uuml;hren. Dazu geh&ouml;ren insbesondere Name, E-Mail-Adresse, Bestellnummer oder eine andere Vertragsangabe sowie freiwillige Freitextangaben.</p>
<p>Die Verarbeitung erfolgt zur Durchf&uuml;hrung vorvertraglicher und vertraglicher Ma&szlig;nahmen sowie zur Erf&uuml;llung unserer gesetzlichen Pflichten im Zusammenhang mit dem Widerrufsrecht (Art. 6 Abs. 1 lit. b und c DSGVO). Technische Daten zur Absicherung des Formulars verarbeiten wir auf Grundlage unseres berechtigten Interesses an Missbrauchs- und Betrugspr&auml;vention (Art. 6 Abs. 1 lit. f DSGVO).</p>
<p>Das Formular wird &uuml;ber die technische Infrastruktur unseres Shopsystems Shopify bereitgestellt. Weitere Informationen zur Verarbeitung durch Shopify findest du in Abschnitt 4 dieser Datenschutzerkl&auml;rung.</p>

<hr>

<h2>12. SSL-/TLS-Verschl&uuml;sselung</h2>
<p>Diese Seite nutzt aus Sicherheitsgr&uuml;nden und zum Schutz der &Uuml;bertragung vertraulicher Inhalte eine SSL-/TLS-Verschl&uuml;sselung. Eine verschl&uuml;sselte Verbindung erkennst du daran, dass die Adresszeile des Browsers von &bdquo;http://&ldquo; auf &bdquo;https://&ldquo; wechselt und an dem Schloss-Symbol in deiner Browserzeile.</p>

<hr>

<h2>13. Deine Rechte als betroffene Person</h2>
<p>Du hast folgende Rechte gegen&uuml;ber uns hinsichtlich deiner personenbezogenen Daten:</p>
<ul>
<li><strong>Recht auf Auskunft</strong> (Art. 15 DSGVO): Du kannst Auskunft &uuml;ber deine von uns verarbeiteten personenbezogenen Daten verlangen.</li>
<li><strong>Recht auf Berichtigung</strong> (Art. 16 DSGVO): Du kannst die Berichtigung unrichtiger Daten verlangen.</li>
<li><strong>Recht auf L&ouml;schung</strong> (Art. 17 DSGVO): Du kannst die L&ouml;schung deiner Daten verlangen, sofern keine gesetzlichen Aufbewahrungspflichten entgegenstehen.</li>
<li><strong>Recht auf Einschr&auml;nkung der Verarbeitung</strong> (Art. 18 DSGVO)</li>
<li><strong>Recht auf Daten&uuml;bertragbarkeit</strong> (Art. 20 DSGVO): Du kannst verlangen, dass wir dir deine Daten in einem strukturierten, g&auml;ngigen und maschinenlesbaren Format &uuml;bermitteln.</li>
<li><strong>Widerspruchsrecht</strong> (Art. 21 DSGVO): Du kannst jederzeit gegen die Verarbeitung deiner personenbezogenen Daten Widerspruch einlegen, soweit die Verarbeitung auf Art. 6 Abs. 1 lit. f DSGVO beruht.</li>
<li><strong>Recht auf Widerruf der Einwilligung</strong> (Art. 7 Abs. 3 DSGVO): Du kannst eine erteilte Einwilligung jederzeit mit Wirkung f&uuml;r die Zukunft widerrufen.</li>
</ul>
<p>Zur Aus&uuml;bung deiner Rechte wende dich bitte an: hello@theartmere.com</p>

<hr>

<h2>14. Beschwerderecht bei einer Aufsichtsbeh&ouml;rde</h2>
<p>Wenn du der Ansicht bist, dass die Verarbeitung deiner personenbezogenen Daten gegen die DSGVO verst&ouml;&szlig;t, hast du das Recht, Beschwerde bei einer Aufsichtsbeh&ouml;rde einzureichen (Art. 77 DSGVO). Die f&uuml;r uns zust&auml;ndige Aufsichtsbeh&ouml;rde ist:</p>
<p>Berliner Beauftragte f&uuml;r Datenschutz und Informationsfreiheit<br>
Alt-Moabit 59-61<br>
10555 Berlin<br>
Deutschland<br>
<a href="https://www.datenschutz-berlin.de" target="_blank" rel="noopener">www.datenschutz-berlin.de</a></p>

<hr>

<h2>15. Speicherdauer</h2>
<p>Wir speichern personenbezogene Daten nur so lange, wie es f&uuml;r die jeweiligen Verarbeitungszwecke erforderlich ist oder gesetzliche Aufbewahrungsfristen bestehen. Nach Ablauf der Frist werden die Daten routinem&auml;&szlig;ig gel&ouml;scht, sofern sie nicht mehr zur Vertragserf&uuml;llung oder Vertragsanbahnung erforderlich sind.</p>
<ul>
<li>Bestelldaten: 10 Jahre (steuerliche Aufbewahrungspflicht gem. &sect; 147 AO)</li>
<li>Server-Logfiles: 30 Tage</li>
<li>Newsletter-Daten: Bis zum Widerruf der Einwilligung</li>
<li>Analyse-Daten: 14 Monate (Google Analytics)</li>
<li>Widerrufskommunikation: solange sie f&uuml;r die Bearbeitung, gesetzliche Aufbewahrungspflichten oder die Geltendmachung, Aus&uuml;bung oder Verteidigung von Rechtsanspr&uuml;chen erforderlich ist</li>
</ul>

<hr>

<h2>16. &Uuml;bermittlung in Drittl&auml;nder</h2>
<p>Eine &Uuml;bermittlung personenbezogener Daten in L&auml;nder au&szlig;erhalb der EU/des EWR (Drittl&auml;nder) erfolgt nur unter den Voraussetzungen der Art. 44 ff. DSGVO. Die &Uuml;bermittlung an die folgenden Dienstleister in den USA erfolgt auf folgender Grundlage:</p>
<ul>
<li><strong>Google LLC</strong> (Google Analytics, Google Pay): EU-US Data Privacy Framework</li>
<li><strong>Meta Platforms, Inc.</strong> (Meta-Pixel): EU-US Data Privacy Framework</li>
<li><strong>Shopify Inc.</strong>: Standardvertragsklauseln gem. Art. 46 Abs. 2 lit. c DSGVO</li>
<li><strong>Intuition Machines, Inc.</strong> (hCaptcha): Standardvertragsklauseln</li>
</ul>

<hr>

<h2>17. &Auml;nderungen dieser Datenschutzerkl&auml;rung</h2>
<p>Wir behalten uns vor, diese Datenschutzerkl&auml;rung anzupassen, damit sie stets den aktuellen rechtlichen Anforderungen entspricht oder um &Auml;nderungen unserer Leistungen in der Datenschutzerkl&auml;rung umzusetzen. F&uuml;r deinen erneuten Besuch gilt dann die neue Datenschutzerkl&auml;rung.</p>

<hr>

<p><em>Diese Datenschutzerkl&auml;rung wurde zuletzt am 22. Juli 2026 aktualisiert.</em></p>` }
      },
      shipping: {
        en: { title: "Shipping Policy", body: `<p><strong>Effective: June 15, 2026</strong></p>
<p>This policy applies to orders placed through www.theartmere.com.</p>

<hr>

<h2>1. Where We Ship</h2>
<p>ARTMERE ships hand-painted artworks internationally, with a primary focus on the United States and Europe. We currently ship to all 50 U.S. states, most countries in the European Union, the United Kingdom and Switzerland.</p>
<p>Import duties, taxes or customs fees may apply for shipments outside the European Union. These charges are set by the destination country and are the collector's responsibility.</p>
<p>If your country is not available at checkout, contact us at hello@theartmere.com and we will confirm whether delivery is possible.</p>

<hr>

<h2>2. Production and Delivery Timeline</h2>
<p>Every ARTMERE artwork is hand-painted to order by a skilled artist. Because each piece is individually created, production and delivery times can vary.</p>
<p><strong>Production:</strong> Usually 5 to 10 days, depending on artwork complexity, size and artist availability.</p>
<p><strong>Preview:</strong> After production, we send preview images for review. Timing depends on how quickly the preview is approved or whether adjustments are requested.</p>
<p><strong>Final quality control and packaging:</strong> After approval, the artwork goes through final quality control, protective finishing if needed and professional packaging.</p>
<p><strong>Shipping:</strong> Once dispatched, insured shipping usually takes 1 to 2 weeks, depending on destination and customs processing.</p>
<p><strong>Estimated total time from order to delivery:</strong> Most artworks arrive within 2 to 4 weeks.</p>
<p>Delivery times are estimates and are not guaranteed. Artist availability, production complexity, courier issues, customs processing, holidays or events outside our control may cause delays. If you need an artwork by a specific date, contact us before ordering so we can confirm what is realistic.</p>

<hr>

<h2>3. Shipping Costs</h2>
<p><strong>Standard shipping is free for standard orders.</strong> ARTMERE covers standard shipping, professional packaging and transit insurance.</p>
<p>If you need express shipping, additional costs may apply. Contact us at hello@theartmere.com and we will confirm available options.</p>

<hr>

<h2>4. Tracking</h2>
<p>Once your approved artwork has been packed and handed to the carrier, you will receive a shipping confirmation by email with tracking details.</p>
<p>If you have not received a shipping confirmation within 5 business days after approving your preview, contact us at hello@theartmere.com.</p>

<hr>

<h2>5. Carriers and Insurance</h2>
<p>We work with trusted logistics partners such as DHL, FedEx, UPS and comparable international carriers depending on destination and package size.</p>
<p><strong>All shipments are insured against loss or damage in transit at no additional cost to you.</strong></p>

<hr>

<h2>6. Customs and Duties</h2>
<p><strong>European Union:</strong> For orders within the EU, no customs duties apply to intra-EU trade. For orders within Germany, German VAT is included in the product price.</p>
<p><strong>United States:</strong> Hand-painted original artworks may qualify under HTS 9701. The final classification is determined by U.S. customs authorities. ARTMERE is not responsible for duties, taxes or fees charged by authorities.</p>
<p><strong>United Kingdom, Switzerland and other non-EU destinations:</strong> Import duties, taxes and customs fees may apply. These charges are set by the destination country and are the collector's responsibility.</p>

<hr>

<h2>7. Damaged or Lost Shipments</h2>
<p>If your artwork arrives damaged, document the issue with clear photos of the packaging and artwork and contact us within 7 business days at hello@theartmere.com with your order number. We will arrange a repair, replacement or refund depending on the situation. Please keep the original packaging until the case is resolved.</p>
<p>If tracking has not moved for more than 10 business days, or the carrier confirms that a package is lost, contact us and we will investigate with the carrier. If the shipment is confirmed lost, we will arrange a replacement shipment or refund.</p>
<p>If your order has not arrived within 30 business days of the confirmed shipping date, contact us right away.</p>

<hr>

<h2>8. Delivery Address</h2>
<p>Please make sure your delivery address is complete and correct, including apartment or unit number, postal code and a valid phone number. If a package is returned because the address was incorrect or incomplete, additional shipping costs may apply.</p>
<p>Large or high-value shipments may require a signature on delivery. Because of the size of our packages, delivery to PO boxes may not be possible.</p>

<hr>

<h2>9. Packaging</h2>
<p>Each artwork is professionally packed with protective materials suitable for hand-painted canvas artwork, including corner protection, cushioning, a sturdy shipping carton and fragile handling labels where appropriate.</p>

<hr>

<h2>10. Contact</h2>
<p>If you have questions about shipping, tracking or this policy, contact us:</p>
<p>The Artmere UG (haftungsbeschraenkt), trading as ARTMERE<br>
Email: hello@theartmere.com<br>
Website: www.theartmere.com</p>
<p>We usually respond within 24 hours on business days.</p>

<hr>

<p><em>This policy was last updated on June 15, 2026. Shipping destinations, delivery estimates and carriers may change. The current version published on our website applies. This document is not legal advice.</em></p>
` },
        de: { title: "Versandrichtlinie", body: `<p><strong>Stand: 15. Juni 2026</strong></p>
<p>Diese Richtlinie gilt f&uuml;r alle Bestellungen &uuml;ber www.theartmere.com.</p>

<hr>

<h2>1. Versandgebiete</h2>
<p>ARTMERE versendet handgemalte Kunstwerke international mit Schwerpunkt auf die USA und Europa. Wir liefern derzeit in alle 50 US-Bundesstaaten (einschlie&szlig;lich Alaska, Hawaii und US-Territorien) sowie in die meisten L&auml;nder der Europ&auml;ischen Union, darunter Deutschland, &Ouml;sterreich, Frankreich, Niederlande, Belgien, Spanien, Italien, Schweden, Polen, D&auml;nemark, Finnland, Irland, Portugal und Griechenland. Zudem liefern wir in das Vereinigte K&ouml;nigreich und die Schweiz.</p>
<p>Bei Bestellungen in das Vereinigte K&ouml;nigreich und die Schweiz k&ouml;nnen Zollgeb&uuml;hren und Einfuhrsteuern bei Ankunft anfallen, die von dir zu tragen sind.</p>
<p>Wir erweitern unser Liefergebiet laufend. Wenn dein Land nicht aufgef&uuml;hrt ist, kontaktiere uns bitte unter hello@theartmere.com, um die Verf&uuml;gbarkeit zu pr&uuml;fen.</p>

<hr>

<h2>2. Produktions- und Lieferzeiten</h2>
<p>Jedes &uuml;ber ARTMERE verkaufte Kunstwerk ist ein handgemaltes Original, das auf Bestellung von einem erfahrenen K&uuml;nstler angefertigt wird. Da jedes St&uuml;ck auf Bestellung gemalt wird, k&ouml;nnen Produktions- und Lieferzeiten variieren.</p>
<p><strong>Produktion:</strong> In der Regel 5 bis 10 Tage, abh&auml;ngig von Designkomplexit&auml;t, Gr&ouml;&szlig;e und K&uuml;nstlerauslastung.</p>
<p><strong>Vorschau:</strong> Nach der Produktion erh&auml;ltst du hochaufl&ouml;sende Vorschaubilder zur Freigabe, was in der Regel 1 bis 3 Werktage dauert, je nachdem ob du sofort freigibst oder Anpassungen w&uuml;nschst.</p>
<p><strong>Endkontrolle und Verpackung:</strong> Nach Freigabe erfolgen die abschlie&szlig;ende Qualit&auml;tskontrolle, ggf. Trocknung des Schutzlacks und die professionelle Verpackung (1 bis 2 Werktage).</p>
<p><strong>Versandzeiten:</strong></p>
<ul>
<li><strong>USA:</strong> In der Regel 1 bis 2 Wochen per DHL Express oder gleichwertigem internationalen Kurierdienst, vollversichert.</li>
<li><strong>Europ&auml;ische Union:</strong> In der Regel 1 bis 2 Wochen per DHL Paket oder gleichwertigem Dienstleister, je nach Zielland.</li>
<li><strong>Vereinigtes K&ouml;nigreich, Schweiz und weitere internationale Ziele:</strong> In der Regel 1 bis 2 Wochen, ggf. l&auml;nger durch Zollabfertigung.</li>
</ul>
<p><strong>Gesch&auml;tzte Gesamtzeit von der Bestellung bis zur Lieferung:</strong> In der Regel 2 bis 4 Wochen, je nach Zielland, Komplexit&auml;t und Freigabezeit.</p>
<p>Alle Lieferzeiten sind Sch&auml;tzungen und nicht garantiert. Verz&ouml;gerungen k&ouml;nnen durch K&uuml;nstlerverf&uuml;gbarkeit, Produktionskomplexit&auml;t, Kurierprobleme, Zollabfertigung, Feiertage oder h&ouml;here Gewalt auftreten. Wenn du einen festen Termin hast, informiere uns bitte vor der Bestellung, damit wir die Machbarkeit best&auml;tigen k&ouml;nnen.</p>

<hr>

<h2>3. Versandkosten</h2>
<p><strong>Der Versand ist f&uuml;r Standardbestellungen immer kostenlos.</strong> Unabh&auml;ngig von Gr&ouml;&szlig;e, Gewicht oder Zielort des Kunstwerks &uuml;bernimmt ARTMERE alle Standardversandkosten, einschlie&szlig;lich professioneller Verpackungsmaterialien, Versandversicherung und Lieferung bis an deine T&uuml;r.</p>
<p>Wenn du einen Expressversand ben&ouml;tigst, k&ouml;nnen zus&auml;tzliche Kosten anfallen. Kontaktiere uns unter hello@theartmere.com f&uuml;r ein Angebot zu Expresslieferoptionen.</p>

<hr>

<h2>4. Sendungsverfolgung und Best&auml;tigung</h2>
<p>Sobald dein freigegebenes Kunstwerk verpackt und an den Versanddienstleister &uuml;bergeben wurde, erh&auml;ltst du eine Versandbest&auml;tigung per E-Mail mit deiner Sendungsnummer, dem Namen des Versanddienstleisters, einem voraussichtlichen Lieferdatum und einem direkten Tracking-Link f&uuml;r Echtzeit-Updates.</p>
<p>Wenn du innerhalb von 5 Werktagen nach Freigabe deiner Vorschau keine Versandbest&auml;tigung erhalten hast, kontaktiere uns bitte unter hello@theartmere.com.</p>

<hr>

<h2>5. Versanddienstleister und Versicherung</h2>
<p>Wir arbeiten mit vertrauensw&uuml;rdigen Logistikpartnern zusammen:</p>
<ul>
<li><strong>DHL Express:</strong> Unser Hauptdienstleister f&uuml;r internationale Sendungen in die USA, mit vollst&auml;ndiger Sendungsverfolgung und Versicherung.</li>
<li><strong>DHL Paket:</strong> Unser Hauptdienstleister f&uuml;r Lieferungen innerhalb der Europ&auml;ischen Union.</li>
<li>Je nach Zielort und Paketformat k&ouml;nnen auch andere Dienstleister wie FedEx, UPS oder lokale Postdienste eingesetzt werden.</li>
</ul>
<p><strong>Alle Sendungen sind w&auml;hrend des Transports vollst&auml;ndig gegen Verlust und Besch&auml;digung versichert, ohne zus&auml;tzliche Kosten f&uuml;r dich.</strong></p>

<hr>

<h2>6. Zoll und Abgaben</h2>
<p><strong>Innerhalb der EU:</strong> F&uuml;r innergemeinschaftlichen Handel fallen keine Zollgeb&uuml;hren an. F&uuml;r Bestellungen innerhalb Deutschlands ist die deutsche Mehrwertsteuer im Produktpreis enthalten.</p>
<p><strong>USA:</strong> Handgemalte Original-Kunstwerke k&ouml;nnen unter der HTS-Position 9701 zollfrei eingef&uuml;hrt werden. Die endg&uuml;ltige Entscheidung liegt bei den US-Zollbeh&ouml;rden. Artmere ist nicht verantwortlich f&uuml;r etwaige von US-Beh&ouml;rden erhobene Z&ouml;lle, Steuern oder Geb&uuml;hren.</p>
<p><strong>Vereinigtes K&ouml;nigreich, Schweiz und andere Nicht-EU-L&auml;nder:</strong> Einfuhrz&ouml;lle, Steuern und Zollbearbeitungsgeb&uuml;hren k&ouml;nnen anfallen und werden durch die Zollbeh&ouml;rde des Ziellandes bestimmt. Diese Kosten tr&auml;gst du. ARTMERE hat keinen Einfluss auf diese Geb&uuml;hren und kann deren H&ouml;he nicht vorhersagen. Wir empfehlen, sich vor der Bestellung bei der &ouml;rtlichen Zollbeh&ouml;rde zu erkundigen.</p>

<hr>

<h2>7. Gefahr&uuml;bergang w&auml;hrend des Transports</h2>
<p>F&uuml;r EU- und deutsche Verbraucher gilt gem&auml;&szlig; &sect; 475 Abs. 2 BGB, dass die Gefahr des zuf&auml;lligen Untergangs und der zuf&auml;lligen Verschlechterung der Ware w&auml;hrend des Transports nicht auf dich &uuml;bergeht, bis die Ware an dich &uuml;bergeben wird. Das bedeutet: Wenn dein Kunstwerk w&auml;hrend des Versands verloren geht oder besch&auml;digt wird, tr&auml;gt ARTMERE das Risiko und wird deine Bestellung ohne Kosten f&uuml;r dich erneut versenden oder erstatten.</p>

<hr>

<h2>8. Besch&auml;digte oder verlorene Sendungen</h2>
<p>Wenn dein Kunstwerk besch&auml;digt ankommt, dokumentiere den Schaden bitte umgehend mit deutlichen Fotos von Verpackung und Kunstwerk und kontaktiere uns innerhalb von 7 Werktagen unter hello@theartmere.com mit deiner Bestellnummer und den Fotos. Wir veranlassen je nach Situation eine Reparatur, einen Ersatz oder eine Erstattung. Bitte bewahre die Originalverpackung auf, bis der Fall vollst&auml;ndig gekl&auml;rt ist.</p>
<p>Wenn deine Sendungsverfolgung seit mehr als 10 Werktagen seit dem letzten Scan keine Bewegung zeigt oder der Dienstleister best&auml;tigt, dass das Paket verloren ist, kontaktiere uns und wir leiten eine Untersuchung ein. Nach Best&auml;tigung des Verlusts veranlassen wir eine kostenlose Nachlieferung oder eine vollst&auml;ndige R&uuml;ckerstattung.</p>
<p>Wenn deine Bestellung nicht innerhalb von 30 Werktagen nach dem best&auml;tigten Versanddatum angekommen ist, kontaktiere uns bitte umgehend.</p>

<hr>

<h2>9. Lieferadresse und Lieferanforderungen</h2>
<p>Bitte stelle sicher, dass deine Lieferadresse bei der Bestellung vollst&auml;ndig und korrekt ist, einschlie&szlig;lich Wohnungs- oder Zimmernummer, Postleitzahl und einer g&uuml;ltigen Telefonnummer. Wir &uuml;bernehmen keine Verantwortung f&uuml;r fehlgeschlagene Zustellungen aufgrund falscher oder unvollst&auml;ndiger Adressangaben. Wird ein Paket aufgrund einer falschen Adresse an uns zur&uuml;ckgeschickt, k&ouml;nnen dir die Kosten f&uuml;r den erneuten Versand berechnet werden.</p>
<p>Eine g&uuml;ltige Telefonnummer ist erforderlich, da Versanddienstleister diese h&auml;ufig f&uuml;r die Lieferkoordination ben&ouml;tigen, insbesondere bei internationalen Sendungen und der Zollabfertigung.</p>
<p>Wir empfehlen eine Lieferadresse, an der jemand die Sendung entgegennehmen kann. Bei hochwertigen Sendungen kann eine Unterschrift bei Lieferung erforderlich sein. Aufgrund der Gr&ouml;&szlig;e unserer Sendungen ist eine Lieferung an Postfachadressen m&ouml;glicherweise nicht m&ouml;glich. Bitte verwende eine physische Stra&szlig;enadresse.</p>

<hr>

<h2>10. Verpackung</h2>
<p>Jedes Kunstwerk wird professionell verpackt, um eine sichere Lieferung zu gew&auml;hrleisten. Die Verpackung umfasst in der Regel Eckenschutz f&uuml;r Kanten und Ecken der Leinwand, mehrere Lagen Luftpolsterfolie oder Schaumstoff zur D&auml;mpfung, einen stabilen doppelwandigen Karton sowie eine &bdquo;Fragile&ldquo;-Kennzeichnung f&uuml;r vorsichtige Handhabung durch den Dienstleister.</p>

<hr>

<h2>11. Kontakt</h2>
<p>Wenn du Fragen zum Versand, zum Lieferstatus oder zu dieser Richtlinie hast, kontaktiere uns bitte:</p>
<p>The Artmere UG (haftungsbeschr&auml;nkt), handelnd unter dem Namen ARTMERE<br>
E-Mail: hello@theartmere.com<br>
Telefon: +49 163 1389600<br>
Website: www.theartmere.com</p>
<p>Unsere Antwortzeit betr&auml;gt in der Regel 24 Stunden an Werktagen.</p>

<hr>

<p><em>Diese Richtlinie wurde zuletzt am 15. Juni 2026 aktualisiert. Versandgebiete, Lieferzeiten und Dienstleister k&ouml;nnen ohne Vorank&uuml;ndigung ge&auml;ndert werden. F&uuml;r die aktuellste Version verweisen wir auf die auf unserer Website ver&ouml;ffentlichte Fassung. Dieses Dokument stellt keine Rechtsberatung dar.</em></p>
` }
      }
    };
    var attempts = 0;
    var maxAttempts = 30;

    function applyPolicyBodyOverride() {
      var policyBody = document.querySelector('.shopify-policy__body .rte');
      if (!policyBody) {
        if (attempts < maxAttempts) {
          attempts += 1;
          setTimeout(applyPolicyBodyOverride, 150);
        }
        return;
      }

      var lang = (document.documentElement.getAttribute('lang') || '').toLowerCase();
      var isGerman = path.indexOf('/de/') === 0 || lang.indexOf('de') === 0;
      var selected = content[policyKey][isGerman ? 'de' : 'en'];
      var policyTitle = document.querySelector('.shopify-policy__title h1, .shopify-policy__title');
      if (policyTitle && selected.title) policyTitle.textContent = selected.title;
      policyBody.innerHTML = selected.body;
    }

    applyPolicyBodyOverride();
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', applyPolicyBodyOverride, { once: true });
    }
    setTimeout(applyPolicyBodyOverride, 600);
    setTimeout(applyPolicyBodyOverride, 1800);
  }

  /* ============================================================
   * JOURNAL PURPOSE MEASUREMENT V1
   * Privacy-safe clicks from one Journal article to a buyer-next step.
   * ============================================================ */
  var JOURNAL_MEASUREMENT_VERSION = 'journal_purpose_measurement_v1_1';

  function journalArticleContext() {
    var match = String(window.location.pathname || '').match(
      /^\/(de\/)?blogs\/journal\/([^/?#]+)\/?$/
    );
    if (!match) return null;
    return {
      language: match[1] ? 'de' : 'en',
      handle: boundedMeasurementValue(decodeURIComponent(match[2]), 120)
    };
  }

  function journalMeasurementDestination(url) {
    if (!url) return null;
    var hostname = String(url.hostname || '').toLowerCase();
    var sameStore = url.origin === window.location.origin ||
      hostname === 'theartmere.com' || hostname === 'www.theartmere.com';
    if (!sameStore) return null;
    var path = String(url.pathname || '').replace(/^\/de(?=\/)/, '');
    if (/^\/products\/[^/]+\/?$/.test(path)) {
      return { kind: 'product', event: 'artmere_journal_product_click' };
    }
    if (/^\/collections\/[^/]+\/?$/.test(path)) {
      return { kind: 'collection', event: 'artmere_journal_collection_click' };
    }
    if (
      /^\/pages\/contact\/?$/.test(path) ||
      /^\/pages\/[^/]*(?:advis|room-fit|help-me-choose)[^/]*\/?$/i.test(path)
    ) {
      return { kind: 'art_advisory', event: 'artmere_journal_advisory_click' };
    }
    return null;
  }

  function journalMeasurementLinkInContent(link) {
    if (!link || typeof link.closest !== 'function') return false;
    if (link.closest('[data-artmere-journal-purpose-link]')) return true;
    var body = link.closest(
      '.article-mag__body, .article-template__content, .article__content, [data-article-body]'
    );
    return !!(body && body.closest && body.closest('article'));
  }

  function initJournalMeasurement() {
    if (window.__artmereJournalMeasurementInitialized) return;
    var article = journalArticleContext();
    if (!article) return;
    window.__artmereJournalMeasurementInitialized = true;
    document.addEventListener('click', function(event) {
      var link = event.target && event.target.closest ? event.target.closest('a[href]') : null;
      if (!link || !journalMeasurementLinkInContent(link)) return;
      var url;
      try {
        url = new URL(link.href, window.location.href);
      } catch(e) {
        return;
      }
      var destination = journalMeasurementDestination(url);
      if (!destination) return;
      if (!event.__artmereJournalMeasurementId) {
        event.__artmereJournalMeasurementId = measurementEventId();
      }
      publishMeasurementEvent(
        destination.event,
        {},
        {
          surface: 'journal_article',
          journal_measurement_version: JOURNAL_MEASUREMENT_VERSION,
          journal_handle: article.handle,
          journal_language: article.language,
          target_kind: destination.kind,
          target_path: boundedMeasurementValue(url.pathname, 240),
          link_text: boundedMeasurementValue(link.textContent.trim(), 120)
        },
        measurementDedupKey(
          destination.event,
          {},
          'journal_article',
          event.__artmereJournalMeasurementId
        )
      );
    }, true);
  }

  /* ============================================================
   * INIT
   * ============================================================ */
  function init() {
    // Auto-redirect German browsers to /de/
    initAutoRedirect();

    // Language and country switching are handled by artmere-locale-sync.js.
    // Keeping them independent preserves the selected market when the language changes.

    // Preserve UTM/click attribution for later cart capture tags
    initMarketingAttributionStorage();

    // Join acquisition, cart and checkout evidence without raw click IDs.
    initMeasurementAcceptance();

    // Measure the curated Abstract list, product selection and confirmed PDP arrival.
    initSearchV2Measurement();
    publishSearchV2PdpBridge();

    // Measure Journal-to-buyer-next-step navigation.
    initJournalMeasurement();

    // Fix product title before Swatch King can modify it
    initTitleFix();

    // Translate Omnisend forms/popups on German pages
    initOmnisendTranslation();

    // Block Omnisend overlays on product and cart pages
    initOmnisendPdpGuard();

    // Legacy cart safety/capture panels are intentionally disabled. The current
    // cart renders its value and trust content natively in the theme sections.

    // Track Collector Credit requests from newsletter and cart forms
    initCollectorCreditSignupTracking();

    // Open all founder videos in a viewport-contained 9:16 player.
    initFounderVideoModals();

    // Play the homepage founder card's video inline inside its own media box.
    initFounderVideoInline();

    // Upgrade cached About portrait markup into the founder video cover
    initAboutFounderVideoFallback();

    // Correct oversized homepage media in stale Shopify full-page cache variants.
    initHomepageImageCacheFallback();

    // Shopify now serves the canonical policy content directly.
    // The legacy hard-coded policy fallback must not overwrite current translations.

    // Swatch King and some theme variant pickers render asynchronously.
    // Try native radios immediately, then keep polling for late-rendered markup.
    var attempts = 0;
    var MAX_ATTEMPTS = 30;
    function tryInitToggle() {
      if (document.querySelector('.artmere-unit-toggle')) return;
      initSizeToggle();
      if (!document.querySelector('.artmere-unit-toggle') && attempts < MAX_ATTEMPTS) {
        attempts++;
        setTimeout(tryInitToggle, 200);
      } else if (!document.querySelector('.artmere-unit-toggle')) {
        // Final fallback: try with native radios
        initSizeToggle();
      }
    }
    tryInitToggle();

    // Re-inject toggle if Swatch King wipes/replaces the swatch container later
    // (e.g. after a variant-URL pre-select triggers a re-render post-init).
    var rerunObserver = new MutationObserver(function() {
      if ((document.querySelector('.swatch-button-title-text span') ||
          document.querySelector('input[type="radio"][name*="options["]')) &&
          !document.querySelector('.artmere-unit-toggle')) {
        initSizeToggle();
      }
    });
    rerunObserver.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
